import React, { useState, useRef } from "react";
import {
    Paper, Typography, Box, Button, Divider, useMediaQuery, Dialog, DialogTitle, DialogContent, DialogActions,
    FormControl, InputLabel, Select, MenuItem, IconButton, Menu, ToggleButtonGroup, ToggleButton
} from "@mui/material";
import { Description, Edit as EditIcon } from "@mui/icons-material";
import { alpha } from "@mui/material/styles";

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

import DescriptionIcon from "@mui/icons-material/Description";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import InfoIcon from '@mui/icons-material/Info';

import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import LockIcon from "@mui/icons-material/Lock";

import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';

import CropPortraitIcon from "@mui/icons-material/CropPortrait";
import CropLandscapeIcon from "@mui/icons-material/CropLandscape";

import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';

import htmlDocx from "html-docx-js/dist/html-docx";
import html2pdf from "html2pdf.js";
import { saveAs } from "file-saver";
import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css';

import { useAuth } from "../../contexts/AuthContext";
import { useSnackbar } from "../../contexts/SnackbarContext";
import { usePlano } from "../../contexts/PlanContext";
import { usePlanModal } from "../../contexts/PlanModalContext";

import UpgradePlanDialog from "../Billing/UpgradePlanDialog";
import ExtraImagesPackageDialog from "../Billing/ExtraImagesPackageDialog";

import api from '../../services/api';
import { getApiErrorMessage } from '../../services/apiUtils';

// Cabeçalho HTML em grade
function getCabecalhoHtml(tipo, logoBase64, opts = {}) {
    const { modo = "render" } = opts; // "render" | "export"
    const isExport = modo === "export";

    const nomeAluno = tipo && String(tipo).toLowerCase().includes("plano")
        ? ``
        : `<tr>
         <td colspan="2" style="border: 1.5px solid #000000; padding: 3px 6px; font-weight: bold; font-size: 12px; line-height: 1.1;">
           NOME DO ALUNO:
         </td>
       </tr>`;

    let logoCellInner = "";

    if (logoBase64) {
        if (isExport) {
            // Export: só a imagem (sem botões)
            logoCellInner = `
        <img src="${logoBase64}" alt="Logo da Escola"
             width="100" height="90"
             style="width:100px;max-width:100px;height:90px;max-height:90px;object-fit:contain;" />
      `;
        } else {
            // Render: container NÃO clicável; sem borda tracejada; X + ⇄ (abaixo do X)
            logoCellInner = `
        <div data-logo-container
             style="width:100px;height:100px;display:flex;align-items:center;justify-content:center;margin:auto;position:relative;background:#fafafa;">
          <button type="button"
                  title="Remover logo"
                  aria-label="Remover logo"
                  onclick="window.__logoRemove && window.__logoRemove(event)"
                  onmousedown="event.preventDefault();event.stopPropagation();"
                  style="position:absolute;top:6px;right:0px;width:22px;height:22px;border-radius:50%;border:1px solid #d0d7de;background:#fff;line-height:1;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:14px;cursor:pointer;box-shadow:0 1px 2px rgba(0,0,0,0.06);">
            ×
          </button>

          <button type="button"
                  title="Substituir logo"
                  aria-label="Substituir logo"
                  onclick="window.__logoTriggerUpload && window.__logoTriggerUpload(event, this)"
                  onmousedown="event.preventDefault();event.stopPropagation();"
                  style="position:absolute;top:34px;right:0px;width:22px;height:22px;border-radius:50%;border:1px solid #d0d7de;background:#fff;line-height:1;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:13px;cursor:pointer;box-shadow:0 1px 2px rgba(0,0,0,0.06);">
            ⇄
          </button>

          <img src="${logoBase64}" alt="Logo da Escola"
               width="100" height="90"
               style="width:100px;max-width:100px;height:90px;max-height:90px;object-fit:contain;pointer-events:none;" />

          <input type="file"
                 accept="image/png,image/jpeg,image/jpg,image/heic,image/heif"
                 style="display:none;"
                 onchange="window.__logoUpload && window.__logoUpload(event)" />
        </div>
      `;
        }
    } else if (isExport) {
        // Export sem logo
        logoCellInner = `<div style="width:100px;height:90px;"></div>`;
    } else {
        // Render sem logo → placeholder (clicável) e SEM borda tracejada
        logoCellInner = `
      <label style="width:100px;height:100px;display:flex;align-items:center;justify-content:center;margin:auto;cursor:pointer;position:relative;background:#fafafa;">
        <span style="font-size:12px;color:#1976d2;height:100%;width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;line-height:1.2;padding:0;">
          Clique para inserir o logo da escola
        </span>
        <input type="file"
               accept="image/png,image/jpeg,image/jpg,image/heic,image/heif"
               style="display:none;"
               onchange="window.__logoUpload && window.__logoUpload(event)" />
      </label>
    `;
    }

    return `
  <div style="max-width:700px;margin:0 auto 16px auto;">
    <table style="width:100%; border-collapse:collapse; font-size:12px; font-family:Arial,sans-serif;">
      <tbody>
        <tr>
          <td rowspan="4" style="border: 1.5px solid #000000; width:120px; min-width:110px; text-align:center; vertical-align:middle; background:#fafafa;">
            ${logoCellInner}
          </td>

          <td style="border: 1.5px solid #000000; padding: 5px 6px 0px 6px; font-weight:bold; font-size: 12px; line-height: 1.0; vertical-align: middle;">
            ESCOLA:
          </td>
          <td style="border: 1.5px solid #000000; padding: 5px 6px 0px 6px; font-weight:bold; font-size: 12px; line-height: 1.0; vertical-align: middle;">
            DATA:
          </td>
        </tr>
        <tr>
          <td style="border: 1.5px solid #000000; padding: 5px 6px 0px 6px; font-weight:bold; font-size: 12px; line-height: 1.0; vertical-align: middle;">
            PROFESSOR(A):
          </td>
          <td style="border: 1.5px solid #000000; padding: 5px 6px 0px 6px; font-weight:bold; font-size: 12px; line-height: 1.0; vertical-align: middle;">
            SÉRIE/TURMA:
          </td>
        </tr>
        <tr>
          <td style="border: 1.5px solid #000000; padding: 5px 6px 0px 6px; font-weight:bold; font-size: 12px; line-height: 1.0; vertical-align: middle;">
            DISCIPLINA:
          </td>
          <td style="border: 1.5px solid #000000; padding: 3px 6px; font-weight: bold; font-size: 12px; line-height: 1.1;">
            TEMA:
          </td>
        </tr>
        ${nomeAluno}
      </tbody>
    </table>
  </div>`;
}

// ImagemUpload igual ao seu
function ImagemUpload({ index, imagem, onUpload, onResize, descricao, onChangeDescricao, planoStatus, canAI, onOpenAI, onUpgrade, aiBusy = false, aiProgress = 0, aiStatusText }) {
    const { showSnackbar } = useSnackbar();
    const fileInputRef = useRef(null);

    const width = imagem?.width || 150;
    const height = imagem?.height || 150;

    const ALLOWED_MIME = new Set(["image/png", "image/jpeg", "image/heic", "image/heif"]);
    const ALLOWED_EXT = new Set(["png", "jpg", "jpeg", "heic", "heif"]);
    const MAX_BYTES = 5 * 1024 * 1024;

    function isValidImage(file) {
        if (!file) return false;
        const mimeOk = file.type ? ALLOWED_MIME.has(file.type) : false;
        const ext = (file.name.split(".").pop() || "").toLowerCase();
        const extOk = ALLOWED_EXT.has(ext);
        const sizeOk = file.size <= MAX_BYTES;
        return (mimeOk || extOk) && sizeOk;
    }

    function handleInvalid(file, inputEl) {
        const sizeMB = (file.size / (1024 * 1024)).toFixed(2);
        const msg = !file
            ? "Nenhum arquivo selecionado."
            : !((file.type && ALLOWED_MIME.has(file.type)) || ALLOWED_EXT.has((file.name.split(".").pop() || "").toLowerCase()))
                ? "Tipo de arquivo não suportado. Use PNG, JPG, JPEG."
                : `Imagem muito grande (${sizeMB}MB). Tamanho máximo: ${(MAX_BYTES / (1024 * 1024)).toFixed(0)}MB.`;

        showSnackbar(msg, "error");
        if (inputEl) inputEl.value = "";
    }

    function handleRemove(e) {
        e.preventDefault();
        e.stopPropagation();
        onUpload(index, { base64: "", width, height, removed: true });
        if (fileInputRef.current) fileInputRef.current.value = "";
    }

    function handleTriggerReplace(e) {
        e.preventDefault();
        e.stopPropagation();
        fileInputRef.current?.click();
    }

    function handleFileChange(e) {
        const inputEl = e.currentTarget;
        const file = inputEl.files?.[0];
        if (!file) return;

        if (!isValidImage(file)) {
            handleInvalid(file, inputEl);
            return;
        }

        const reader = new FileReader();
        reader.onload = (ev) => onUpload(index, { base64: ev.target.result, width, height });
        reader.readAsDataURL(file);

        // permitir re-upload do mesmo arquivo
        inputEl.value = "";
    }

    const hasImage = !!imagem?.base64;

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <ResizableBox
                width={width}
                height={height}
                minConstraints={[150, 150]}
                maxConstraints={[300, 300]}
                resizeHandles={["se"]}
                onResizeStop={(e, { size }) => onResize(index, size)}
            >
                <div
                    onClick={() => { if (!hasImage) fileInputRef.current?.click(); }}
                    style={{
                        display: "inline-block",
                        width: "100%",
                        height: "100%",
                        border: "1.8px dashed #1976d2",   // (questões) mantém os “tracinhos”
                        background: "#fafafa",
                        textAlign: "center",
                        verticalAlign: "middle",
                        position: "relative",
                        cursor: hasImage ? "default" : "pointer",
                    }}
                >

                    {aiBusy && (
                        <div
                            style={{
                                position: "absolute",
                                inset: 0,
                                background: "rgba(250,250,250,0.88)",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 10,
                                zIndex: 3
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div style={{ fontWeight: 700, color: "#444" }}>
                                {aiProgress >= 95 ? aiStatusText : `Gerando... ${Math.min(100, Math.max(0, Math.round(aiProgress)))}%`}
                            </div>

                            <div
                                style={{
                                    width: "70%",
                                    height: 8,
                                    borderRadius: 999,
                                    background: "rgba(0,0,0,0.08)",
                                    overflow: "hidden"
                                }}
                            >
                                <div
                                    style={{
                                        height: "100%",
                                        width: `${Math.min(100, Math.max(0, aiProgress))}%`,
                                        background: "#1976d2",
                                        transition: "width 160ms linear"
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    <div style={{ position: "absolute", right: 6, top: 6, zIndex: 2, display: "none" }}>
                        <Tooltip title={canAI ? "Gerar imagem com IA" : "Disponível no plano MESTRE"}>
                            <span>
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (canAI) onOpenAI(index);
                                    }}
                                    disabled={!canAI}
                                    sx={{
                                        background: "rgba(255,255,255,0.9)",
                                        border: "1px solid rgba(0,0,0,0.08)"
                                    }}
                                >
                                    <AutoAwesomeIcon fontSize="inherit" />
                                </IconButton>
                            </span>
                        </Tooltip>

                        {!canAI && (
                            <Button
                                size="small"
                                variant="text"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onUpgrade();
                                }}
                                sx={{ ml: 0.5 }}
                            >
                                Fazer upgrade
                            </Button>
                        )}
                    </div>


                    {/* Remover */}
                    {hasImage && (
                        <button
                            type="button"
                            onClick={handleRemove}
                            title="Remover imagem"
                            aria-label="Remover imagem"
                            style={{
                                position: "absolute",
                                top: 6,
                                right: 6,
                                width: 24,
                                height: 24,
                                borderRadius: 12,
                                border: "1px solid #d0d7de",
                                background: "#fff",
                                lineHeight: 1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 700,
                                fontSize: 14,
                                cursor: "pointer",
                                boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                            }}
                            onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        >
                            ×
                        </button>
                    )}

                    {/* Substituir (sempre abaixo do X) */}
                    {hasImage && (
                        <button
                            type="button"
                            onClick={handleTriggerReplace}
                            title="Substituir imagem"
                            aria-label="Substituir imagem"
                            style={{
                                position: "absolute",
                                top: 34,
                                right: 6,
                                width: 24,
                                height: 24,
                                borderRadius: 12,
                                border: "1px solid #d0d7de",
                                background: "#fff",
                                lineHeight: 1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 700,
                                fontSize: 13,
                                cursor: "pointer",
                                boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                            }}
                            onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
                        >
                            ⇄
                        </button>
                    )}

                    {/* Gerar com IA (sempre abaixo do ⇄) */}
                    {hasImage && (
                        <button
                            type="button"
                            onClick={handleTriggerReplace}
                            title="Gerar nova imagem com IA"
                            aria-label="Gerar nova imagem com IA"
                            style={{
                                position: "absolute",
                                top: 62,
                                right: 6,
                                width: 24,
                                height: 24,
                                borderRadius: 12,
                                border: "1px solid #d0d7de",
                                background: "#fff",
                                lineHeight: 1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 700,
                                fontSize: 13,
                                cursor: "pointer",
                                boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
                            }}
                            onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); if (canAI) onOpenAI?.(index); }}
                        >
                            ✨
                        </button>
                    )}

                    {hasImage ? (
                        <img
                            src={imagem.base64}
                            alt={`Imagem ${index + 1}`}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                pointerEvents: "none"
                            }}
                        />
                    ) : (
                        <>
                            <span
                                style={{
                                    fontSize: 13,
                                    color: "#1976d2",
                                    height: "100%",
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                    lineHeight: "1.2",
                                    padding: 0,
                                }}
                            >
                                Clique para subir a imagem
                            </span>

                            {canAI ? (
                                <Button
                                    type="button"
                                    startIcon={<AutoAwesomeIcon />}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onOpenAI?.(index);
                                    }}
                                    sx={(theme) => ({
                                        position: "absolute",
                                        bottom: 8,
                                        left: 13,
                                        borderRadius: 10,
                                        px: "10px",
                                        py: "6px",
                                        fontSize: 12,
                                        fontWeight: 900,
                                        textTransform: "none",
                                        backgroundColor: "#fff",
                                        color: theme.palette.primary.main,
                                        border: `1px solid ${alpha(theme.palette.primary.main, 0.45)}`,
                                        "& .MuiButton-startIcon": {
                                            color: theme.palette.secondary.main
                                        },
                                        "&:hover": {
                                            backgroundColor: alpha(theme.palette.secondary.main, 0.04),
                                            borderColor: theme.palette.primary.main,
                                            boxShadow: `0 2px 6px ${alpha(theme.palette.secondary.main, theme.palette.mode === "dark" ? 0.45 : 0.25)}`,
                                        },
                                    })}
                                >
                                    Gerar com IA
                                </Button>

                            ) : (
                                <Tooltip title={planoStatus === "G" ? "Assine o plano MENTOR ou MESTRE e gere as imagens com 1 clique" : "Disponível somente nos planos MENTOR e MESTRE"} arrow>
                                    <Button
                                        type="button"
                                        startIcon={<LockIcon />}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            onUpgrade();
                                        }}
                                        sx={(theme) => ({
                                            position: "absolute",
                                            bottom: 8,
                                            left: 13,
                                            borderRadius: 10,
                                            px: "10px",
                                            py: "6px",
                                            fontSize: 12,
                                            fontWeight: 900,
                                            textTransform: "none",
                                            backgroundColor: "#fff",
                                            color: theme.palette.primary.main,
                                            border: `1px solid ${alpha(theme.palette.primary.main, 0.45)}`,
                                            "& .MuiButton-startIcon": {
                                                color: theme.palette.secondary.main
                                            },
                                            "&:hover": {
                                                backgroundColor: alpha(theme.palette.secondary.main, 0.04),
                                                borderColor: theme.palette.primary.main,
                                                boxShadow: `0 2px 6px ${alpha(theme.palette.secondary.main, theme.palette.mode === "dark" ? 0.45 : 0.25)}`,
                                            },
                                        })}
                                    >
                                        Gerar com IA
                                    </Button>
                                </Tooltip>
                            )}
                        </>
                    )}


                </div>

                {/* input único (placeholder ou botão ⇄) */}
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/png,image/jpeg,image/jpg,image/heic,image/heif"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                />
            </ResizableBox>

            <div
                style={{
                    fontSize: Math.max(14, Math.round(width / 15)),
                    color: "#1976d2",
                    marginTop: 6,
                    maxWidth: width,
                    textAlign: "left",
                }}
            >
                {typeof onChangeDescricao !== "function" ? (
                    <EditableText
                        value={descricao ?? ""}
                        onChange={(v) => onChangeDescricao(v, index)}
                        placeholder="Imagem de apoio"
                        tag="div"
                        style={{
                            fontSize: Math.max(14, Math.round(width / 15)),
                            color: "#1976d2",
                            marginTop: 6,
                            maxWidth: width,
                            textAlign: "left",
                        }}
                    />
                ) : (
                    descricao
                )}
            </div>
        </div>
    );
}

// Component editável inline com ícone de lápis
function EditableText({ value, onChange, tag = "div", style = {}, ...rest }) {
    const [hover, setHover] = useState(false);
    const Tag = tag;
    const isInlineTag = tag === "span" || tag === "strong";

    return (
        <Tag
            contentEditable
            suppressContentEditableWarning
            spellCheck={false}
            style={{
                outline: 'none',
                borderRadius: 3,
                transition: 'box-shadow 0.1s',
                cursor: 'text',
                boxShadow: hover ? "0 0 0 2px #1976d2" : undefined,
                ...style,
                position: "relative",
                boxSizing: "border-box",
                maxWidth: style.maxWidth || "100%",
                minWidth: 0,
                overflowWrap: style.overflowWrap || "anywhere",
                wordBreak: style.wordBreak || "break-word",
                whiteSpace: style.whiteSpace || "pre-wrap",
                display: style.display || (isInlineTag ? "inline-block" : "block"),
                paddingRight: hover ? Math.max(Number(style.paddingRight) || 0, 24) : style.paddingRight,
            }}
            onBlur={e => {
                const text = e.currentTarget.textContent;
                onChange(text === "\u00A0" ? "" : text);
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            {...rest}
        >
            {value && value.length > 0 ? value : "\u00A0"}
            {hover && <EditIcon sx={{
                position: "absolute",
                right: 4,
                top: 2,
                fontSize: 16,
                color: "#1976d2",
                pointerEvents: "none",
                backgroundColor: "#fff",
                borderRadius: "50%",
            }} />}
        </Tag>
    );
}


function isBlocoTextoBase(q, idx) {
    if (idx !== 0 || !q) return false;

    return (
        q.tipo === "texto_base" ||
        q.tipo === "interpretacao" ||
        (
            q?.conteudo_apoio?.tipo === "texto" &&
            q?.numero == null &&
            !String(q?.enunciado || "").trim()
        )
    );
}

function isBlocoProducaoTextual(q, idx) {
    if (idx !== 0 || !q) return false;
    return q.tipo === "producao_textual" && q?.numero == null;
}

function isQuestaoGrafico(q) {
    return q?.tipo === "ilustrativa" && q?.grafico && Array.isArray(q.grafico.categorias) && Array.isArray(q.grafico.valores);
}

function isQuestaoProducaoTextual(q) {
    return q?.tipo === "producao_textual";
}

function getQuantidadeLinhasResposta(q) {
    return isQuestaoProducaoTextual(q) ? 12 : 3;
}

function escapeHtml(v) {
    return String(v ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}

function planoToText(value) {
    if (value == null) return "";
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
        return String(value).trim();
    }
    if (Array.isArray(value)) {
        return value.map(planoToText).filter(Boolean).join("; ").trim();
    }
    if (typeof value === "object") {
        const candidate = value.titulo || value.title || value.descricao || value.texto || value.label || value.value;
        if (candidate != null) return planoToText(candidate);
        return Object.entries(value)
            .filter(([, v]) => v != null && v !== "")
            .map(([k, v]) => `${k}: ${planoToText(v)}`)
            .filter(Boolean)
            .join("; ")
            .trim();
    }
    return String(value).trim();
}

function planoAsArray(value) {
    if (Array.isArray(value)) return value.filter((item) => item != null && item !== "");
    if (value == null || value === "") return [];
    if (typeof value === "string") {
        return value
            .split(/\n|•|●/g)
            .map((item) => item.trim())
            .filter(Boolean);
    }
    return [value];
}

function hasPlanoValue(value) {
    if (Array.isArray(value)) return value.some(hasPlanoValue);
    if (value == null) return false;
    if (typeof value === "object") return Object.values(value).some(hasPlanoValue);
    return String(value).trim().length > 0;
}

function getBnccCodesArray(bncc) {
    const items = Array.isArray(bncc) ? bncc : (bncc ? [bncc] : []);
    return items
        .map((item) => {
            if (typeof item === "string") return item.trim();
            const codigo = String(item?.codigo || "").trim();
            const descricao = String(item?.descricao || "").trim();
            return [codigo, descricao].filter(Boolean).join(" - ");
        })
        .filter(Boolean);
}

// function getBnccCodesText(bncc, separator = "; ") {
//     return getBnccCodesArray(bncc).join(separator);
// }

function getPlanoHabilidadesText(resultado) {
    const habilidadesBncc = getBnccCodesArray(resultado?.bncc);
    const habilidadeGerada = planoToText(resultado?.habilidade);

    if (habilidadesBncc.length > 1) {
        return habilidadesBncc.join("\n");
    }

    return habilidadeGerada || habilidadesBncc.join("\n");
}

function stripPlanoLeadingNumber(value) {
    return String(value || "").replace(/^\s*\d+[.)-]?\s*/, "").trim();
}

function normalizePlanoTitle(value) {
    return stripPlanoLeadingNumber(value)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ")
        .trim();
}

function isSamePlanoTitle(a, b) {
    const normalizedA = normalizePlanoTitle(a);
    const normalizedB = normalizePlanoTitle(b);
    return !!normalizedA && !!normalizedB && normalizedA === normalizedB;
}

function formatPlanoHtmlValue(value, H) {
    return String(H(planoToText(value))).replace(/\n/g, "<br/>");
}


function normalizePlanoDevelopmentItem(item) {
    if (typeof item === "string") {
        return {
            titulo: "",
            duracao: "",
            descricao: item,
            acoes_professor: [],
            acoes_alunos: [],
        };
    }

    const raw = item && typeof item === "object" ? item : {};

    return {
        titulo: raw.titulo || raw.title || "",
        duracao: raw.duracao || raw.tempo || raw.tempo_estimado || "",
        descricao: raw.descricao || raw.texto || raw.orientacao || "",
        orientacoes: planoAsArray(raw.orientacoes),
        acoes_professor: planoAsArray(raw.acoes_professor || raw.acoesProfessor || raw.professor),
        acoes_alunos: planoAsArray(raw.acoes_alunos || raw.acoesAlunos || raw.alunos),
    };
}

function normalizePlanoTable(value) {
    const raw = value && typeof value === "object" && !Array.isArray(value) ? value : {};
    const colunas = Array.isArray(raw.colunas) ? raw.colunas : (Array.isArray(raw.columns) ? raw.columns : []);
    const linhas = Array.isArray(raw.linhas) ? raw.linhas : (Array.isArray(raw.rows) ? raw.rows : []);

    return {
        titulo: raw.titulo || raw.title || "",
        colunas: colunas.map((col) => planoToText(col)).filter(Boolean),
        linhas: linhas
            .map((linha) => Array.isArray(linha) ? linha.map((celula) => planoToText(celula)) : [planoToText(linha)])
            .filter((linha) => linha.some(Boolean)),
    };
}

function normalizePlanoFields(resultado) {
    if (!resultado) {
        return {
            tipo_conteudo: "",
            tema: "",
            disciplina: "",
            serie: "",
            quantidade_aulas: "",
            periodo_realizacao: "",
            habilidade: "",
            competencia_socioemocional: [],
            objeto_conhecimento: "",
            objetivo: "",
            objetivos_especificos: [],
            espaco_fisico: [],
            metodologia: [],
            recursos_didaticos: [],
            recursos_necessarios: "",
            desenvolvimento: [],
            cronograma: normalizePlanoTable(null),
            tabela_sintese: normalizePlanoTable(null),
            avaliacao: [],
            referencias: [],
            observacoes: "",
        };
    }

    return {
        tipo_conteudo: resultado.tipo_conteudo || "",
        tema: resultado.tema || "",
        disciplina: resultado.disciplina || "",
        serie: resultado.serie || "",
        quantidade_aulas: resultado.quantidade_aulas || resultado.quantidadeAulas || "",
        periodo_realizacao: resultado.periodo_realizacao || resultado.periodoRealizacao || "",
        habilidade: getPlanoHabilidadesText(resultado),
        competencia_socioemocional: planoAsArray(resultado.competencia_socioemocional || resultado.competenciaSocioemocional),
        objeto_conhecimento: resultado.objeto_conhecimento || resultado.objetoConhecimento || "",
        objetivo: resultado.objetivo || "",
        objetivos_especificos: planoAsArray(resultado.objetivos_especificos || resultado.objetivosEspecificos),
        espaco_fisico: planoAsArray(resultado.espaco_fisico || resultado.espacoFisico),
        metodologia: planoAsArray(resultado.metodologia),
        recursos_didaticos: planoAsArray(resultado.recursos_didaticos || resultado.recursosDidaticos || resultado.recursos_necessarios),
        recursos_necessarios: resultado.recursos_necessarios || "",
        desenvolvimento: planoAsArray(resultado.desenvolvimento).map(normalizePlanoDevelopmentItem),
        cronograma: normalizePlanoTable(resultado.cronograma),
        tabela_sintese: normalizePlanoTable(resultado.tabela_sintese || resultado.tabelaSintese),
        avaliacao: planoAsArray(resultado.avaliacao),
        referencias: planoAsArray(resultado.referencias),
        observacoes: resultado.observacoes || "",
    };
}

function buildPlanoListHtml(items, H) {
    const arr = planoAsArray(items).map(planoToText).filter(Boolean);
    if (!arr.length) return "";

    return `<div style="margin:6px 0 12px 0; padding:0;">
        ${arr.map((item) => `<p style="margin:0 0 4px 0; padding:0; line-height:1.35; overflow-wrap:break-word; word-break:normal;">&#8226;&nbsp;${H(item)}</p>`).join("")}
    </div>`;
}

function buildPlanoTableHtml(tableValue, H) {
    const table = normalizePlanoTable(tableValue);
    if (!table.colunas.length && !table.linhas.length) return "";

    return `
        <div style="margin:14px 0 18px 0; page-break-inside: avoid;">
            ${table.titulo ? `<div style="font-weight:700; margin-bottom:6px;">${H(table.titulo)}</div>` : ""}
            <table style="width:100%; border-collapse:collapse; table-layout:fixed; font-size:14px; background:#fff;">
                ${table.colunas.length ? `
                    <thead>
                        <tr>
                            ${table.colunas.map((col) => `<th style="border:1.3px solid #222; padding:7px 8px; text-align:left; font-weight:700; background:#f5f5f5; overflow-wrap:anywhere; word-break:break-word;">${H(col)}</th>`).join("")}
                        </tr>
                    </thead>
                ` : ""}
                <tbody>
                    ${table.linhas.map((linha) => `
                        <tr>
                            ${linha.map((celula) => `<td style="border:1.3px solid #222; padding:7px 8px; vertical-align:top; overflow-wrap:anywhere; word-break:break-word;">${H(celula)}</td>`).join("")}
                        </tr>
                    `).join("")}
                </tbody>
            </table>
        </div>`;
}


function buildPlanoDevelopmentHtml(items, H) {
    const etapas = planoAsArray(items).map(normalizePlanoDevelopmentItem).filter(hasPlanoValue);
    if (!etapas.length) return "";

    return `<div style="margin:6px 0 12px 0; padding:0;">
        ${etapas.map((item, idx) => {
        const professor = buildPlanoListHtml(item.acoes_professor, H);
        const alunos = buildPlanoListHtml(item.acoes_alunos, H);
        const orientacoes = buildPlanoListHtml(item.orientacoes, H);
        const titulo = stripPlanoLeadingNumber(item.titulo);
        const tituloLinha = titulo
            ? `<strong>${idx + 1}.&nbsp;${H(titulo)}</strong>${item.duracao ? ` <span style="font-weight:400;">(${H(item.duracao)})</span>` : ""}`
            : `<strong>${idx + 1}.</strong>`;

        return `<div style="margin:0 0 12px 0; padding:0; page-break-inside:avoid; overflow-wrap:break-word; word-break:normal;">
                <p style="margin:0 0 4px 0; padding:0; line-height:1.35;">${tituloLinha}</p>
                ${item.descricao ? `<p style="margin:4px 0 0 0; padding:0; line-height:1.35;">${H(item.descricao)}</p>` : ""}
                ${orientacoes ? `<div style="margin-top:6px;"><p style="margin:0 0 4px 0; padding:0; line-height:1.35;"><b>Orientações:</b></p>${orientacoes}</div>` : ""}
                ${professor ? `<div style="margin-top:6px;"><p style="margin:0 0 4px 0; padding:0; line-height:1.35;"><b>Ações do professor:</b></p>${professor}</div>` : ""}
                ${alunos ? `<div style="margin-top:6px;"><p style="margin:0 0 4px 0; padding:0; line-height:1.35;"><b>Ações dos alunos:</b></p>${alunos}</div>` : ""}
            </div>`;
    }).join("")}
    </div>`;
}

function isPlanoBlueSection(title) {
    return ["Desenvolvimento", "Avaliação", "Observações"].includes(
        String(title || "").replace(/:$/, "").trim()
    );
}

function buildPlanoSectionHtml(title, content) {
    if (!content) return "";

    const isBlue = isPlanoBlueSection(title);

    const borderColor = isBlue ? "#dbeafe" : "#e5e7eb";
    const borderLeftColor = isBlue ? "#1976d2" : "#9ca3af";
    const backgroundColor = isBlue ? "#f8fbff" : "#fafafa";
    const titleColor = isBlue ? "#174ea6" : "#374151";

    return `<div style="margin:12px 0; padding:10px 12px; border:1px solid ${borderColor}; border-left:4px solid ${borderLeftColor}; background:${backgroundColor}; border-radius:6px; page-break-inside:avoid;">
        <div style="font-weight:700; color:${titleColor}; margin-bottom:5px;">${title}:</div>
        <div>${content}</div>
    </div>`;
}

function buildPlanoTextSectionHtml(title, value, H, destaque = false) {
    if (!hasPlanoValue(value)) return "";
    return buildPlanoSectionHtml(H(title), `<div>${H(value)}</div>`, destaque);
}

function buildPlanoAulaExportHtml(planoRaw, resultado, U, H, tipoArquivo) {
    const plano = normalizePlanoFields({ ...resultado, ...planoRaw });
    const tituloMarginBottom = tipoArquivo === "docx" ? 18 : 24;

    const infoRows = [
        ["Componente Curricular", plano.disciplina || resultado?.disciplina],
        ["Ano/Série/Turma", plano.serie || resultado?.serie],
        ["Quantidade de aulas", plano.quantidade_aulas],
        ["Período de realização", plano.periodo_realizacao],
        ["Tema", plano.tema || resultado?.tema],
        ["Habilidades", plano.habilidade],
    ].filter(([, value]) => hasPlanoValue(value));

    const infoTable = infoRows.length ? `
        <table style="width:100%; border-collapse:collapse; margin:0 0 18px 0; font-size:14px;">
            <tbody>
                ${infoRows.map(([label, value]) => `
                    <tr>
                        <td bgcolor="#eef6ff" style="width:28%; border:1.3px solid #222; padding:7px 8px; font-weight:700; background:#eef6ff; background-color:#eef6ff; color:#174ea6; vertical-align:top;">${H(label)}</td>
                        <td style="border:1.3px solid #222; padding:7px 8px; vertical-align:top;">${formatPlanoHtmlValue(value, H)}</td>
                    </tr>
                `).join("")}
            </tbody>
        </table>` : "";

    return `${plano.tema ? `<h2 style="text-align:center; font-weight:600; margin:0 0 ${tituloMarginBottom}px 0; font-family:Arial,sans-serif; line-height:1.2;">${H(plano.tipo_conteudo || resultado?.tipo_conteudo || "Plano de Aula")}</h2>` : ""}
        ${infoTable}
        ${buildPlanoSectionHtml("Competência Socioemocional", buildPlanoListHtml(plano.competencia_socioemocional, H))}
        ${buildPlanoTextSectionHtml("Objeto de Conhecimento", plano.objeto_conhecimento, H)}
        ${buildPlanoTextSectionHtml("Objetivo", plano.objetivo, H)}
        ${buildPlanoSectionHtml("Objetivos Específicos", buildPlanoListHtml(plano.objetivos_especificos, H))}
        ${buildPlanoSectionHtml("Espaço Físico", buildPlanoListHtml(plano.espaco_fisico, H))}
        ${buildPlanoSectionHtml("Metodologia", buildPlanoListHtml(plano.metodologia, H))}
        ${buildPlanoSectionHtml("Recursos Didáticos", buildPlanoListHtml(plano.recursos_didaticos, H))}
        ${buildPlanoSectionHtml("Desenvolvimento", buildPlanoDevelopmentHtml(plano.desenvolvimento, H), true)}
        ${buildPlanoTableHtml(plano.cronograma, H)}
        ${buildPlanoTableHtml(plano.tabela_sintese, H)}
        ${buildPlanoSectionHtml("Avaliação", buildPlanoListHtml(plano.avaliacao, H))}
        ${buildPlanoTextSectionHtml("Observações", plano.observacoes, H)}`;
}

function escapeXml(v) {
    return String(v ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");
}

function svgToDataUrl(svg) {
    return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
}

function buildGraficoSvg(grafico, opts = {}) {
    const width = Number(opts.width || 520);
    const height = Number(opts.height || 320);

    const titulo = String(grafico?.titulo || "");
    const tipo = String(grafico?.tipo || "colunas").toLowerCase();
    const categorias = Array.isArray(grafico?.categorias) ? grafico.categorias : [];
    const valores = Array.isArray(grafico?.valores) ? grafico.valores.map(v => Number(v) || 0) : [];

    if (!categorias.length || !valores.length || categorias.length !== valores.length) {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}"></svg>`;
    }

    const COLOR_POOL = [
        "#ef5350", "#ec407a", "#ab47bc", "#7e57c2", "#5c6bc0",
        "#42a5f5", "#29b6f6", "#26c6da", "#26a69a", "#66bb6a",
        "#9ccc65", "#d4e157", "#ffca28", "#ffa726", "#ff7043",
        "#8d6e63", "#78909c", "#f06292", "#9575cd", "#4db6ac",
        "#81c784", "#ffd54f", "#90caf9", "#a1887f", "#7986cb"
    ];

    function shuffleArray(arr) {
        const copy = [...arr];
        for (let i = copy.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [copy[i], copy[j]] = [copy[j], copy[i]];
        }
        return copy;
    }

    function getChartColors(total) {
        const shuffled = shuffleArray(COLOR_POOL);

        if (total <= shuffled.length) {
            return shuffled.slice(0, total);
        }

        const result = [];
        while (result.length < total) {
            result.push(...shuffleArray(COLOR_POOL));
        }
        return result.slice(0, total);
    }

    const colors = Array.isArray(grafico?.cores) && grafico.cores.length >= categorias.length
        ? grafico.cores.slice(0, categorias.length)
        : getChartColors(categorias.length);

    if (tipo === "pizza") {
        const cx = 180;
        const cy = 170;
        const r = 90;
        const total = valores.reduce((a, b) => a + b, 0) || 1;

        let angleStart = -Math.PI / 2;
        const slices = valores.map((v, i) => {
            const angle = (v / total) * Math.PI * 2;
            const angleEnd = angleStart + angle;

            const x1 = cx + r * Math.cos(angleStart);
            const y1 = cy + r * Math.sin(angleStart);
            const x2 = cx + r * Math.cos(angleEnd);
            const y2 = cy + r * Math.sin(angleEnd);
            const largeArc = angle > Math.PI ? 1 : 0;

            const path = `
                <path d="M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2} Z"
                      fill="${colors[i]}" stroke="#333" stroke-width="1.5" />
            `;

            angleStart = angleEnd;
            return path;
        }).join("");

        const legend = categorias.map((cat, i) => `
            <g transform="translate(320, ${80 + i * 34})">
                <rect x="0" y="-12" width="18" height="18" fill="${colors[i]}" stroke="#333" stroke-width="1" />
                <text x="28" y="2" font-size="16" font-family="Arial" fill="#222">${escapeXml(cat)} (${valores[i]})</text>
            </g>
        `).join("");

        return `
            <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 520 320">
                <rect width="100%" height="100%" fill="#fff"/>
                <text x="260" y="28" text-anchor="middle" font-size="24" font-weight="700" font-family="Arial" fill="#222">${escapeXml(titulo)}</text>
                ${slices}
                ${legend}
            </svg>
        `;
    }

    const max = Math.max(Number(grafico?.max || 0), ...valores, 1);
    const escala = Math.max(1, Number(grafico?.escala || 1));

    const chartLeft = 60;
    const chartTop = 50;
    const chartWidth = 390;
    const chartHeight = 190;
    const baseY = chartTop + chartHeight;
    const steps = Math.ceil(max / escala);

    const barCount = categorias.length;
    const slot = chartWidth / barCount;
    const barWidth = Math.min(52, slot * 0.55);

    const grid = Array.from({ length: steps + 1 }).map((_, i) => {
        const value = i * escala;
        const y = baseY - (value / max) * chartHeight;
        return `
            <g>
                <line x1="${chartLeft}" y1="${y}" x2="${chartLeft + chartWidth}" y2="${y}" stroke="#cfcfcf" stroke-width="1" />
                <text x="${chartLeft - 10}" y="${y + 5}" text-anchor="end" font-size="16" font-weight="700" font-family="Arial" fill="#222">${value}</text>
            </g>
        `;
    }).join("");

    const bars = categorias.map((cat, i) => {
        const v = valores[i];
        const h = (v / max) * chartHeight;
        const x = chartLeft + i * slot + (slot - barWidth) / 2;
        const y = baseY - h;
        return `
            <g>
                <rect x="${x}" y="${y}" width="${barWidth}" height="${h}" fill="${colors[i]}" stroke="#333" stroke-width="1.5" />
                <text x="${x + barWidth / 2}" y="${baseY + 28}" text-anchor="middle" font-size="14" font-weight="700" font-family="Arial" fill="#222">${escapeXml(cat)}</text>
            </g>
        `;
    }).join("");

    return `
        <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 520 320">
            <rect width="100%" height="100%" fill="#fff"/>
            <text x="260" y="28" text-anchor="middle" font-size="20" font-family="Arial" fill="#222">${escapeXml(titulo)}</text>
            ${grid}
            <line x1="${chartLeft}" y1="${chartTop}" x2="${chartLeft}" y2="${baseY}" stroke="#333" stroke-width="2.5" />
            <line x1="${chartLeft}" y1="${baseY}" x2="${chartLeft + chartWidth}" y2="${baseY}" stroke="#333" stroke-width="2.5" />
            ${bars}
        </svg>
    `;
}

function GraficoRender({ grafico, doubleColumn = false }) {
    const svgWidth = doubleColumn ? 320 : 520;
    const svgHeight = doubleColumn ? 220 : 320;
    const svg = buildGraficoSvg(grafico, { width: svgWidth, height: svgHeight });
    const src = svgToDataUrl(svg);

    return (
        <div style={{ marginLeft: 24, marginTop: 18, marginBottom: 10 }}>
            <img
                src={src}
                alt={grafico?.titulo || "Gráfico"}
                style={{
                    width: "100%",
                    maxWidth: doubleColumn ? 320 : 520,
                    height: "auto",
                    display: "block",
                    background: "#fff"
                }}
            />
        </div>
    );
}

function ensureGraficoColors(grafico) {
    if (!grafico) return grafico;

    const categorias = Array.isArray(grafico.categorias) ? grafico.categorias : [];
    if (!categorias.length) return grafico;

    if (Array.isArray(grafico.cores) && grafico.cores.length >= categorias.length) {
        return grafico;
    }

    const COLOR_POOL = [
        "#ef5350", "#ec407a", "#ab47bc", "#7e57c2", "#5c6bc0",
        "#42a5f5", "#29b6f6", "#26c6da", "#26a69a", "#66bb6a",
        "#9ccc65", "#d4e157", "#ffca28", "#ffa726", "#ff7043",
        "#8d6e63", "#78909c", "#f06292", "#9575cd", "#4db6ac",
        "#81c784", "#ffd54f", "#90caf9", "#a1887f", "#7986cb"
    ];

    const shuffleArray = (arr) => {
        const copy = [...arr];
        for (let i = copy.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [copy[i], copy[j]] = [copy[j], copy[i]];
        }
        return copy;
    };

    let cores = [];
    while (cores.length < categorias.length) {
        cores.push(...shuffleArray(COLOR_POOL));
    }

    return {
        ...grafico,
        cores: cores.slice(0, categorias.length)
    };
}

function splitQuestoesEmDuasColunas(lista = []) {
    const meio = Math.ceil(lista.length / 2);
    return {
        esquerda: lista.slice(0, meio),
        direita: lista.slice(meio),
    };
}

// Questões renderizáveis e editáveis
function QuestoesRender({ planoStatus, questoes, imagensPorQuestao, setImagensPorQuestao, onChange, etapa, serie, disciplina, canAI, onOpenAIDialog, onUpgrade, aiLoading, aiTarget, aiProgress, aiStatusText, layoutMode = "single", isMobile = false }) {

    // Força caixa alta APENAS quando etapa=Fundamental I e série=1º ou 2º ano.
    // A normalização com NFD é usada SÓ para COMPARAR, não altera nenhum texto renderizado.
    function mustUppercase(etapaVal, serieVal) {
        if (!etapaVal || !serieVal) return false;
        const etapaNorm = String(etapaVal).normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().trim();
        if (etapaNorm !== 'fundamental i') return false;
        const serieNorm = String(serieVal).normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().trim();
        // aceita 1º/1°/1o e 2º/2°/2o, com ou sem espaço/ponto
        return /^([12])\s*[º°o]?\.?\s*ano$/.test(serieNorm);
    }
    const IS_UPPER = mustUppercase(etapa, serie);
    const U = (v) => IS_UPPER ? String(v ?? '').toUpperCase() : v;

    // Handler para resize
    function handleResize(questaoIdx, imgIdx, size) {
        setImagensPorQuestao(old => {
            const copia = [...old];
            const imgs = copia[questaoIdx] ? [...copia[questaoIdx]] : [];
            const imgAtual = imgs[imgIdx] || {};
            imgs[imgIdx] = { ...imgAtual, width: size.width, height: size.height };
            copia[questaoIdx] = imgs;
            return copia;
        });
    }

    function handleQuestaoChange(idx, campo, valor) {
        const novas = questoes.map((q, i) =>
            i === idx ? { ...q, [campo]: valor } : q
        );
        onChange(novas);
    }

    function handleAlternativaChange(qIdx, altIdx, valor) {
        const novas = questoes.map((q, i) => {
            if (i !== qIdx) return q;
            const novasAlts = (Array.isArray(q.alternativas) ? q.alternativas : []).map((a, j) =>
                j === altIdx ? valor : a
            );
            return { ...q, alternativas: novasAlts };
        });
        onChange(novas);
    }

    function handleItemChange(qIdx, itemIdx, valor) {
        const novas = questoes.map((q, i) => {
            if (i !== qIdx) return q;
            const novosItens = (Array.isArray(q.itens) ? q.itens : []).map((item, j) =>
                j === itemIdx ? { ...item, texto: valor } : item
            );
            return { ...q, itens: novosItens };
        });
        onChange(novas);
    }

    function renderLinhasItem(item) {
        const tipoLinha = String(item?.linha_resposta || "curta").toLowerCase();
        const quantidade = tipoLinha === "media" ? 2 : (disciplina.toLowerCase() !== 'matemática' ? 2 : 1);

        return (
            <div style={{ flex: 1, minWidth: 90 }}>
                {/*Array.from({ length: quantidade }).map((_, idx) => (*/
                    <div
                        //key={idx}
                        style={{
                            borderBottom: "1.5px solid #222",
                            minHeight: 18,
                            marginTop: 0, //idx === 0 ? 0 : 6,
                            width: quantidade === 1 ? "20%" : "100%",
                        }}
                    />
                /*))*/}
            </div>
        );
    }

    // Bloco de apoio, renderiza só se existir e for tipo conhecido
    function ConteudoApoio({ conteudo_apoio, questaoIdx }) {
        if (!conteudo_apoio) return null;

        if (conteudo_apoio.tipo === "tabela") {
            return (
                <div style={{ marginLeft: 24, marginBottom: 12 }}>
                    {conteudo_apoio.titulo && (
                        <div style={{ marginBottom: 6, color: "#555" }}>
                            {conteudo_apoio.titulo}
                        </div>
                    )}

                    <table style={{ borderCollapse: "collapse", background: "#fff", fontSize: 14 }}>
                        <thead>
                            <tr>
                                {(conteudo_apoio.colunas || []).map((col, i) => (
                                    <th
                                        key={i}
                                        style={{ border: "1.5px solid #000", padding: "6px 10px", fontWeight: 700 }}
                                    >
                                        {col}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {(conteudo_apoio.linhas || []).map((linha, i) => (
                                <tr key={i}>
                                    {linha.map((cel, j) => (
                                        <td
                                            key={j}
                                            style={{ border: "1.5px solid #000", padding: "6px 10px" }}
                                        >
                                            {cel}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        // TEXTO
        if (conteudo_apoio.tipo === "texto") {

            const txt = (conteudo_apoio.texto ?? conteudo_apoio.descricao ?? "").trim();
            if (!txt) return null; // <<--- evita placeholder vazio

            return (
                <div style={{ marginLeft: 24, marginBottom: 10, color: "#555" }}>
                    <EditableText
                        value={U(conteudo_apoio.texto ?? "")}
                        onChange={v => {
                            const novasQuestoes = questoes.map((q, idx) =>
                                idx === questaoIdx
                                    ? {
                                        ...q,
                                        conteudo_apoio: {
                                            ...q.conteudo_apoio,
                                            texto: v,
                                        },
                                    }
                                    : q
                            );
                            onChange(novasQuestoes);
                        }}
                        tag="div"
                        style={{ color: "#555", minHeight: 22 }}
                    />
                </div>
            );
        }

        // IMAGEM
        // Conteúdo de apoio como "imagem" foi removido
        /*if (conteudo_apoio.tipo === "imagem") {
            return (
                <>

                    <div
                        style={{
                            marginLeft: 24,
                            marginTop: 8,
                            fontSize: 12,
                            color: "#1976d2",
                        }}
                    >
                        <InfoIcon sx={{ verticalAlign: "middle", fontSize: 15 }} /> Formatos aceitos.: <strong>PNG, JPG, JPEG, HEIC, HEIF</strong> | Máx.: <strong>5MB</strong>
                    </div>

                    <div style={{ marginLeft: 24, marginBottom: 10, marginTop: 8, }}>
                        <ImagemUpload
                            index={0}
                            imagem={imagensPorQuestao[questaoIdx]?.apoio || {}}
                            onUpload={(_, dados) => {
                                setImagensPorQuestao(old => {
                                    const copy = [...old];
                                    copy[questaoIdx] = {
                                        ...(copy[questaoIdx] || {}),
                                        apoio: {
                                            ...dados,
                                            width: dados.width || 150,
                                            height: dados.height || 150,
                                        },
                                    };
                                    return copy;
                                });
                            }}
                            onResize={(_, size) => {
                                setImagensPorQuestao(old => {
                                    const copy = [...old];
                                    const apoioAtual = copy[questaoIdx]?.apoio || {};
                                    copy[questaoIdx] = {
                                        ...(copy[questaoIdx] || {}),
                                        apoio: {
                                            ...apoioAtual,
                                            ...size,
                                        },
                                    };
                                    return copy;
                                });
                            }}
                            descricao={U(conteudo_apoio.descricao ?? "")}
                            onChangeDescricao={v => {
                                const novasQuestoes = questoes.map((q, idx) =>
                                    idx === questaoIdx
                                        ? {
                                            ...q,
                                            conteudo_apoio: {
                                                ...q.conteudo_apoio,
                                                descricao: v,
                                            },
                                        }
                                        : q
                                );
                                onChange(novasQuestoes);
                            }}
                            planoStatus={planoStatus}
                            canAI={canAI}
                            onOpenAI={() => onOpenAIDialog(questaoIdx, 0, "apoio")}
                            onUpgrade={onUpgrade}
                            aiBusy={
                                aiLoading &&
                                aiTarget?.kind === "apoio" &&
                                aiTarget?.questaoIdx === questaoIdx
                            }
                            aiProgress={aiProgress}
                            aiStatusText={aiStatusText}
                        />
                    </div>
                </>
            );
        }*/

        return null;
    }

    const disciplinaNormalize = String(disciplina || '')
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
        .trim();

    const questoesComIndice = questoes.map((q, idx) => ({ q, idx }));
    const blocoTextoBase = questoesComIndice.find(({ q, idx }) => isBlocoTextoBase(q, idx));
    const blocoProducaoTextual = questoesComIndice.find(({ q, idx }) => isBlocoProducaoTextual(q, idx));

    const questoesNumeradas = questoesComIndice.filter(
        ({ q, idx }) => !isBlocoTextoBase(q, idx) && !isBlocoProducaoTextual(q, idx)
    );

    const usarDuasColunas = layoutMode === "double" && !isMobile;
    const { esquerda: questoesEsquerda, direita: questoesDireita } = splitQuestoesEmDuasColunas(questoesNumeradas);

    function renderQuestaoBloco(q, idx) {
        return (
            <div
                key={q.numero || idx}
                style={{
                    marginBottom: 28,
                    position: "relative",
                    width: "100%",
                    breakInside: "avoid",
                    pageBreakInside: "avoid",
                }}
            >
                <div style={{ fontWeight: 'bold', marginTop: 14, marginBottom: 14, display: "flex", alignItems: "flex-start" }}>
                    <span style={{
                        marginRight: 7,
                        minWidth: 28,
                        textAlign: "right",
                        lineHeight: "1.6"
                    }}>
                        {q.numero}.
                    </span>

                    <EditableText
                        value={
                            U(
                                q.tipo === "ilustrativa"
                                    ? (q.enunciado
                                        ? q.enunciado.replace(/\[ *IMAGEM *\]/gi, "").replace(/\s+/g, " ").trim()
                                        : "")
                                    : q.enunciado
                            )
                        }
                        onChange={v => handleQuestaoChange(idx, "enunciado", v)}
                        tag="div"
                        style={{ flex: 1, cursor: "text" }}
                    />
                </div>

                <ConteudoApoio conteudo_apoio={q.conteudo_apoio} questaoIdx={idx} />

                {isQuestaoGrafico(q) && (
                    <GraficoRender grafico={q.grafico} doubleColumn={usarDuasColunas} />
                )}

                {!isQuestaoGrafico(q) && Array.isArray(q.imagens) && q.imagens.length > 0 && (
                    <>
                        <div
                            style={{
                                marginLeft: 24,
                                marginTop: 8,
                                fontSize: 12,
                                color: "#1976d2",
                            }}
                        >
                            <InfoIcon sx={{ verticalAlign: "middle", fontSize: 15 }} /> Formatos aceitos.: <strong>PNG, JPG, JPEG, HEIC, HEIF</strong> | Máx.: <strong>5MB</strong>
                        </div>

                        <div
                            style={{
                                marginLeft: 24,
                                marginTop: 8,
                                display: "flex",
                                gap: 25,
                                flexWrap: "wrap",
                            }}
                        >
                            {q.imagens.map((img, i) => (
                                <div key={i} style={{ textAlign: "center" }}>
                                    <ImagemUpload
                                        index={i}
                                        imagem={imagensPorQuestao[idx]?.[i]}
                                        onUpload={(imgIdx, dados) => {
                                            const imgsAtualizadas = [...(imagensPorQuestao[idx] || [])];
                                            imgsAtualizadas[imgIdx] = {
                                                ...dados,
                                                width: dados.width || 150,
                                                height: dados.height || 150,
                                            };
                                            const novoImagensPorQuestao = [...imagensPorQuestao];
                                            novoImagensPorQuestao[idx] = imgsAtualizadas;
                                            setImagensPorQuestao(novoImagensPorQuestao);
                                        }}
                                        onResize={(imgIdx, size) => handleResize(idx, imgIdx, size)}
                                        descricao={U(img.descricao)}
                                        onChangeDescricao={v => {
                                            const novasQuestoes = questoes.map((qst, qIdx) =>
                                                qIdx === idx
                                                    ? {
                                                        ...qst,
                                                        imagens: qst.imagens.map((imagem, imgIdx) =>
                                                            imgIdx === i
                                                                ? { ...imagem, descricao: v }
                                                                : imagem
                                                        ),
                                                    }
                                                    : qst
                                            );
                                            onChange(novasQuestoes);
                                        }}
                                        planoStatus={planoStatus}
                                        canAI={canAI}
                                        onOpenAI={() => onOpenAIDialog(idx, i, "questao")}
                                        onUpgrade={onUpgrade}
                                        aiBusy={
                                            aiLoading &&
                                            aiTarget?.kind === "questao" &&
                                            aiTarget?.questaoIdx === idx &&
                                            aiTarget?.imgIdx === i
                                        }
                                        aiProgress={aiProgress}
                                        aiStatusText={aiStatusText}
                                    />
                                </div>
                            ))}
                        </div>
                    </>
                )}

                {q.tipo === "ilustrativa"
                    && (!Array.isArray(q.alternativas) || q.alternativas.length === 0)
                    && (!q.campo_resposta)
                    && (!Array.isArray(q.imagens) || q.imagens.length === 0)
                    && (!isQuestaoGrafico(q))
                    && (
                        <div style={{ marginLeft: 24, marginTop: 22, marginBottom: 8 }}>
                            <div
                                style={{
                                    border: "1.8px solid #222",
                                    borderRadius: 12,
                                    width: "100%",
                                    maxWidth: usarDuasColunas ? 240 : 500,
                                    height: usarDuasColunas ? 140 : "35vw",
                                    maxHeight: usarDuasColunas ? 140 : 250,
                                    minHeight: 120,
                                    background: "#fff",
                                    display: "block",
                                    boxSizing: "border-box"
                                }}
                            />
                        </div>
                    )
                }

                {q.tipo === "ilustrativa" && Array.isArray(q.itens) && q.itens.length > 0 && (
                    <div style={{ marginLeft: 24, marginTop: 14, marginBottom: 8 }}>
                        {q.itens.map((item, itemIdx) => (
                            <div
                                key={itemIdx}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    marginBottom: 10,
                                }}
                            >
                                <EditableText
                                    value={U(item.texto)}
                                    onChange={v => handleItemChange(idx, itemIdx, v)}
                                    tag="div"
                                    style={{
                                        minWidth: 180,
                                        maxWidth: "70%",
                                        lineHeight: "1.4",
                                    }}
                                />
                                {renderLinhasItem(item)}
                            </div>
                        ))}
                    </div>
                )}

                {q.afirmacao && (
                    <div style={{ marginLeft: 24, marginTop: 10, marginBottom: 4, fontStyle: "italic", color: "#555" }}>
                        {U(q.afirmacao)}
                    </div>
                )}

                {Array.isArray(q.alternativas) && q.tipo !== "ilustrativa" &&
                    q.alternativas.map((alt, i) => (
                        (alt !== 'Verdadeiro' && alt !== 'Falso' && alt !== 'True' && alt !== 'False')
                            ? (
                                <div key={i} style={{ marginLeft: 24 }}>
                                    <EditableText
                                        value={U(alt)}
                                        onChange={v => handleAlternativaChange(idx, i, v)}
                                        tag="div"
                                    />
                                </div>
                            )
                            : null
                    ))
                }

                {q.tipo === "verdadeiro_falso" && (
                    <>
                        <div style={{ marginTop: 15, marginLeft: 24 }}>
                            (&nbsp;&nbsp;&nbsp;&nbsp;) <EditableText value={disciplinaNormalize !== "ingles" ? U("Verdadeiro") : U("True")} onChange={() => { }} tag="span" style={{ display: "inline" }} />
                        </div>
                        <div style={{ marginTop: 5, marginLeft: 24 }}>
                            (&nbsp;&nbsp;&nbsp;&nbsp;) <EditableText value={disciplinaNormalize !== "ingles" ? U("Falso") : U("False")} onChange={() => { }} tag="span" style={{ display: "inline" }} />
                        </div>
                    </>
                )}

                {q.campo_resposta === "aberta" && q.campo_resposta !== "nao_aplicavel" &&
                    !/(desenhe|ilustre)/i.test(q.enunciado || '') && (
                        <div style={{ marginLeft: 24 }}>
                            {[1, 2, 3].map(l => (
                                <div
                                    key={l}
                                    style={{
                                        borderBottom: "1.5px solid #222",
                                        minHeight: 24,
                                        margin: "2px 0 0 0",
                                        width: "100%",
                                    }}
                                />
                            ))}
                        </div>
                    )}
            </div>
        );
    }

    return (
        <>
            {blocoTextoBase && (() => {
                const { q, idx } = blocoTextoBase;
                const img = Array.isArray(q.imagens) ? q.imagens[0] : null;
                const imgState = Array.isArray(imagensPorQuestao[idx]) ? imagensPorQuestao[idx][0] : null;

                return (
                    <div
                        key={`texto-base-${idx}`}
                        style={{
                            marginBottom: 28,
                            display: "flex",
                            gap: 18,
                            alignItems: "flex-start",
                            flexWrap: "wrap"
                        }}
                    >
                        <div style={{ marginLeft: 24, display: img !== null ? "" : "none" }}>
                            <ImagemUpload
                                index={0}
                                imagem={imgState}
                                onUpload={(imgIdx, dados) => {
                                    const imgsAtualizadas = [...(imagensPorQuestao[idx] || [])];
                                    imgsAtualizadas[imgIdx] = {
                                        ...dados,
                                        width: dados.width || 170,
                                        height: dados.height || 170,
                                    };
                                    const novoImagensPorQuestao = [...imagensPorQuestao];
                                    novoImagensPorQuestao[idx] = imgsAtualizadas;
                                    setImagensPorQuestao(novoImagensPorQuestao);
                                }}
                                onResize={(imgIdx, size) => handleResize(idx, imgIdx, size)}
                                descricao={U(img?.descricao || "")}
                                onChangeDescricao={v => {
                                    const novasQuestoes = questoes.map((qst, qIdx) =>
                                        qIdx === idx
                                            ? {
                                                ...qst,
                                                imagens: [
                                                    {
                                                        ...(qst.imagens?.[0] || { ordem: 0 }),
                                                        ordem: 0,
                                                        descricao: v
                                                    }
                                                ],
                                            }
                                            : qst
                                    );
                                    onChange(novasQuestoes);
                                }}
                                planoStatus={planoStatus}
                                canAI={canAI}
                                onOpenAI={() => onOpenAIDialog(idx, 0, "questao")}
                                onUpgrade={onUpgrade}
                                aiBusy={
                                    aiLoading &&
                                    aiTarget?.kind === "questao" &&
                                    aiTarget?.questaoIdx === idx &&
                                    aiTarget?.imgIdx === 0
                                }
                                aiProgress={aiProgress}
                                aiStatusText={aiStatusText}
                            />
                        </div>

                        <div style={{ flex: 1, minWidth: 260 }}>
                            <ConteudoApoio conteudo_apoio={q.conteudo_apoio} questaoIdx={idx} />
                        </div>
                    </div>
                );
            })()}

            {blocoProducaoTextual && (() => {
                const { q, idx } = blocoProducaoTextual;

                return (
                    <div
                        key={`producao-textual-${idx}`}
                        style={{
                            marginBottom: 28,
                            width: "100%",
                        }}
                    >
                        <div
                            style={{
                                textAlign: "center",
                                fontWeight: "bold",
                                marginBottom: 18,
                                lineHeight: "1.7",
                                maxWidth: 820,
                                marginLeft: "auto",
                                marginRight: "auto"
                            }}
                        >
                            <EditableText
                                value={U(q.enunciado ?? "")}
                                onChange={v => handleQuestaoChange(idx, "enunciado", v)}
                                tag="div"
                                style={{
                                    textAlign: "center",
                                    lineHeight: "1.7",
                                    maxWidth: 820,
                                    margin: "0 auto"
                                }}
                            />
                        </div>

                        {!isQuestaoGrafico(q) && Array.isArray(q.imagens) && q.imagens.length > 0 && (
                            <>
                                <div
                                    style={{
                                        marginTop: 8,
                                        fontSize: 12,
                                        color: "#1976d2",
                                        textAlign: "center",
                                    }}
                                >
                                    <InfoIcon sx={{ verticalAlign: "middle", fontSize: 15 }} /> Formatos aceitos.: <strong>PNG, JPG, JPEG, HEIC, HEIF</strong> | Máx.: <strong>5MB</strong>
                                </div>

                                <div
                                    style={{
                                        marginTop: 12,
                                        display: "flex",
                                        justifyContent: "center",
                                        gap: 25,
                                        flexWrap: "wrap",
                                    }}
                                >
                                    {q.imagens.map((img, i) => (
                                        <div key={i} style={{ textAlign: "center" }}>
                                            <ImagemUpload
                                                index={i}
                                                imagem={imagensPorQuestao[idx]?.[i]}
                                                onUpload={(imgIdx, dados) => {
                                                    const imgsAtualizadas = [...(imagensPorQuestao[idx] || [])];
                                                    imgsAtualizadas[imgIdx] = {
                                                        ...dados,
                                                        width: dados.width || 150,
                                                        height: dados.height || 150,
                                                    };
                                                    const novoImagensPorQuestao = [...imagensPorQuestao];
                                                    novoImagensPorQuestao[idx] = imgsAtualizadas;
                                                    setImagensPorQuestao(novoImagensPorQuestao);
                                                }}
                                                onResize={(imgIdx, size) => handleResize(idx, imgIdx, size)}
                                                descricao={U(img.descricao)}
                                                onChangeDescricao={v => {
                                                    const novasQuestoes = questoes.map((qst, qIdx) =>
                                                        qIdx === idx
                                                            ? {
                                                                ...qst,
                                                                imagens: qst.imagens.map((imagem, imgIdx) =>
                                                                    imgIdx === i
                                                                        ? { ...imagem, descricao: v }
                                                                        : imagem
                                                                ),
                                                            }
                                                            : qst
                                                    );
                                                    onChange(novasQuestoes);
                                                }}
                                                planoStatus={planoStatus}
                                                canAI={canAI}
                                                onOpenAI={() => onOpenAIDialog(idx, i, "questao")}
                                                onUpgrade={onUpgrade}
                                                aiBusy={
                                                    aiLoading &&
                                                    aiTarget?.kind === "questao" &&
                                                    aiTarget?.questaoIdx === idx &&
                                                    aiTarget?.imgIdx === i
                                                }
                                                aiProgress={aiProgress}
                                                aiStatusText={aiStatusText}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}

                        <div style={{ marginTop: 18 }}>
                            {Array.from({ length: getQuantidadeLinhasResposta(q) }, (_, idxLinha) => (
                                <div
                                    key={idxLinha}
                                    style={{
                                        borderBottom: "1.5px solid #222",
                                        minHeight: 24,
                                        margin: "2px 0 0 0",
                                        width: "100%",
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                );
            })()}

            {usarDuasColunas ? (
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        columnGap: "32px",
                        alignItems: "start",
                    }}
                >
                    <div>
                        {questoesEsquerda.map(({ q, idx }) => renderQuestaoBloco(q, idx))}
                    </div>

                    <div>
                        {questoesDireita.map(({ q, idx }) => renderQuestaoBloco(q, idx))}
                    </div>
                </div>
            ) : (
                <div>
                    {questoesNumeradas.map(({ q, idx }) => renderQuestaoBloco(q, idx))}
                </div>
            )}
        </>
    );
}

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

// Função para Dialog de geração de imagem IA
function AIGerarImagemDialog({ open, onClose, onGenerate, locked, loading, onUpgrade }) {

    const [estilo, setEstilo] = React.useState("desenho");
    const [size, setSize] = React.useState("1024x1024");
    const [modoCor, setModoCor] = React.useState("colorido");
    const [fundo, setFundo] = React.useState("branco");

    React.useEffect(() => {
        if (open) {
            setEstilo("desenho");
            setSize("1024x1024");
            setModoCor("colorido");
            setFundo("branco");
        }
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Gerar imagem com IA</DialogTitle>

            <DialogContent>
                <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                    <InputLabel>Estilo</InputLabel>
                    <Select
                        value={estilo}
                        label="Estilo"
                        onChange={(e) => setEstilo(e.target.value)}
                    >
                        <MenuItem value="real">Real (foto)</MenuItem>
                        <MenuItem value="cartoon">Cartoon</MenuItem>
                        <MenuItem value="desenho">Desenho</MenuItem>
                        <MenuItem value="flat">Flat (vetorial)</MenuItem>
                        <MenuItem value="aquarela">Aquarela</MenuItem>
                    </Select>
                </FormControl>

                <FormControl fullWidth size="small" sx={{ mt: 2 }}>
                    <InputLabel>Cores</InputLabel>
                    <Select
                        value={modoCor}
                        label="Cores"
                        onChange={(e) => setModoCor(e.target.value)}
                    >
                        <MenuItem value="colorido">Colorido</MenuItem>
                        <MenuItem value="preto_branco">Preto e branco</MenuItem>
                    </Select>
                </FormControl>

                <FormControl fullWidth size="small" sx={{ mt: 2 }}>
                    <InputLabel>Fundo</InputLabel>
                    <Select
                        value={fundo}
                        label="Fundo"
                        onChange={(e) => setFundo(e.target.value)}
                    >
                        <MenuItem value="branco">Com fundo</MenuItem>
                        <MenuItem value="transparente">Sem fundo (transparente PNG)</MenuItem>
                    </Select>
                </FormControl>

                <FormControl fullWidth size="small" sx={{ mt: 2, display: "none" }}>
                    <InputLabel>Tamanho</InputLabel>
                    <Select
                        value={size}
                        label="Tamanho"
                        onChange={(e) => setSize(e.target.value)}
                    >
                        <MenuItem value="1024x1024">Quadrado</MenuItem>
                        <MenuItem value="1536x1024">Paisagem</MenuItem>
                        <MenuItem value="1024x1536">Retrato</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>

            <DialogActions sx={{
                p: 2,
                zIndex: 10
            }}>
                <Button onClick={onClose} variant="text">Fechar</Button>

                <Button
                    onClick={() => onGenerate({ estilo, size, modoCor, fundo })}
                    variant="contained"
                    startIcon={<AutoAwesomeIcon />}
                    disabled={locked || loading}
                >
                    {loading ? "Gerando..." : "Gerar Imagem"}
                </Button>

            </DialogActions>
        </Dialog>
    );
}

// COMPONENTE PRINCIPAL -----------------------------
export default function ResultDocumentCard({ resultado, onNovaConsulta, mostrarAvaliacao, onAvaliarClick, tipoChamadaAvaliacao }) {
    const { user } = useAuth();
    const { showSnackbar, closeSnackbar } = useSnackbar();
    const { planoStatus, planoTipo, fetchStatusPlano } = usePlano();
    const { openPlanModal } = usePlanModal();

    const [questoes, setQuestoes] = useState(resultado?.questoes || []);
    const idGeracao = Number(resultado?.id_geracao || 0) || null;

    React.useEffect(() => {
        setQuestoes(
            (resultado?.questoes || []).map(q =>
                q?.grafico
                    ? { ...q, grafico: ensureGraficoColors(q.grafico) }
                    : q
            )
        );
    }, [resultado]);

    const [imagensPorQuestao, setImagensPorQuestao] = useState([]);
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const [layoutMode, setLayoutMode] = useState("single"); // "single" | "double"

    const tipo = resultado?.tipo_conteudo;
    const disciplina = resultado?.disciplina;
    const etapa = resultado?.etapa_ensino;
    const serie = resultado?.serie;

    // Exportação em "paisagem" e "retrato"
    const [exportMenu, setExportMenu] = useState({
        anchorEl: null,
        tipoArquivo: null, // "docx" | "pdf"
    });

    const openExportMenu = (event, tipoArquivo) => {
        setExportMenu({
            anchorEl: event.currentTarget,
            tipoArquivo,
        });
    };

    const closeExportMenu = () => {
        setExportMenu({
            anchorEl: null,
            tipoArquivo: null,
        });
    };

    const handleEscolherOrientacao = (orientacao) => {
        const tipoArquivo = exportMenu.tipoArquivo;
        closeExportMenu();
        if (tipoArquivo) {
            exportarWordOuPdf(tipoArquivo, orientacao);
        }
    };

    const [openUpgrade, setOpenUpgrade] = useState(false);
    const [openExtraImages, setOpenExtraImages] = useState(false);

    const planoUpper = String(planoTipo || "").toUpperCase().trim();
    const statusPlanoUpper = String(planoStatus || "").toUpperCase().trim();
    const isPartnerAccess = statusPlanoUpper === "B";
    const canAI = (["A", "B", "I"].includes(statusPlanoUpper) && (planoUpper === "MENTOR" || planoUpper === "MESTRE"));

    // opções de upgrade para liberar IA de imagens
    const upgradeOptionsForAI =
        planoUpper === "PROFESSOR" ? ["MENTOR", "MESTRE"] :
            planoUpper === "MENTOR" ? ["MESTRE"] :
                ["MESTRE"];

    const [aiOpen, setAiOpen] = useState(false);
    const [aiTarget, setAiTarget] = useState(null);
    // aiTarget: { questaoIdx, imgIdx, kind: "questao" | "apoio" }

    const [aiLoading, setAiLoading] = useState(false);
    const [aiProgress, setAiProgress] = useState(0);

    const [aiStatusText, setAiStatusText] = useState("");

    const openAIDialog = (questaoIdx, imgIdx = 0, kind = "questao") => {
        setAiTarget({ questaoIdx, imgIdx, kind });
        setAiOpen(true);
    };

    const closeAIDialog = () => {
        setAiOpen(false);
        setAiTarget(null);
        setAiProgress(0);
    };

    const closeAIDialogOnly = () => {
        setAiOpen(false);
    };


    const handleUpgradeClick = () => {

        showSnackbar(
            "Geração de imagens com IA disponível nos planos Mentor e Mestre.",
            "info",
            <Button
                size="small"
                variant="contained"
                onClick={() => {
                    closeSnackbar();        // 👈 fecha o snackbar
                    planoStatus === "G" ? openPlanModal() : setOpenUpgrade(true)  // 👈 ação principal
                }}
                sx={{
                    borderRadius: 5,
                    bgcolor: '#fff',
                    color: '#000',
                    fontWeight: "bold",
                    fontSize: 11,
                    textTransform: 'none',
                    '&:hover': {
                        bgcolor: '#f5f5f5',
                    },
                }}
            >
                <RocketLaunchRoundedIcon sx={{ fontSize: 12, fontWeight: "bold", mr: 0.2 }} />{planoStatus === "G" ? (!isMobile ? "Assinar Plano" : "Assinar") : (!isMobile ? "Atualizar Plano" : "Atualizar")}
            </Button>
        );

        //setOpenUpgrade(true);
    };

    const handleGenerateAI = async ({ estilo, size, modoCor, fundo }) => {
        if (!canAI || !aiTarget) return;

        let t;
        const start = performance.now();

        // fecha o dialog imediatamente
        closeAIDialogOnly();

        try {
            setAiLoading(true);
            setAiProgress(1);

            const { questaoIdx, imgIdx, kind } = aiTarget;

            const q = questoes?.[questaoIdx] || {};

            if (isQuestaoGrafico(q)) {
                showSnackbar("Gráficos agora são renderizados automaticamente, sem geração por IA.", "info");
                return;
            }

            /*const enunciadoRaw = String(q.enunciado || "").replace(/\[IMAGEM\]/gi, "").trim();

            // se o enunciado induz múltiplas imagens, não mande (evita split/comparação)
            const isMulti = /(imagens?|figuras?)\s+(abaixo|a\s+seguir)|qual\s+delas|observe\s+as\s+(imagens?|figuras?)|marque\s+qual/i
                .test(enunciadoRaw);

            const enunciado = isMulti ? "" : enunciadoRaw;*/

            const descFromState =
                kind === "apoio"
                    ? String(imagensPorQuestao?.[questaoIdx]?.apoio?.descricao || "")
                    : String(imagensPorQuestao?.[questaoIdx]?.[imgIdx]?.descricao || "");

            const descFromModel =
                kind === "apoio"
                    ? String(q?.conteudo_apoio?.descricao || "")
                    : String(q?.imagens?.[imgIdx]?.descricao || "");

            const desc = (descFromState || descFromModel || "Imagem de apoio").trim();

            const promptBase = [
                "Contexto escolar (atividade/avaliação).",
                //enunciado ? `Enunciado: ${enunciado}` : "",
                desc ? `Descrição do que deve aparecer: ${desc}` : "",
                "Obrigatório: UMA única imagem, UMA única cena (sem divisão).",
                "Proibido: split-screen, duas cenas lado a lado, antes/depois, colagem, grid."
            ].filter(Boolean).join("\n");

            // Progresso por tempo decorrido
            const expected = 15000; // tempo padrão do loading

            setAiStatusText("Gerando...");

            t = setInterval(() => {
                const elapsed = performance.now() - start;
                const x = Math.min(1, elapsed / expected);               // 0..1
                const eased = 1 - Math.pow(1 - x, 2);                    // ease-out
                const p = Math.round(5 + eased * 90);                    // 5..95
                setAiProgress((old) => (old >= 95 ? 95 : Math.max(old, p)));
                if (p >= 95) {
                    const dots = Math.floor(((performance.now() - start) / 350) % 4); // 0..3
                    setAiStatusText(`Finalizando${".".repeat(dots)}`);
                } else {
                    setAiStatusText("Gerando...");
                }
            }, 120);

            const res = await api.post(
                "/pedagogical-content/images",
                { generationId: idGeracao, promptBase, style: estilo, size, colorMode: modoCor, background: fundo }
            )

            if (!res.data?.status || !res.data?.dataUrl) {
                showSnackbar("Não foi possível gerar a imagem.", "error");
                return;
            }

            const dataUrl = res.data.dataUrl;

            const remaining = res.data?.remaining;

            if (typeof remaining === "number" && remaining === 3) {
                showSnackbar(
                    "Atenção: restam apenas 3 gerações de imagem neste mês.",
                    "warning"
                );
            }

            setImagensPorQuestao((prev) => {
                const copy = Array.isArray(prev) ? [...prev] : [];
                const slot = copy[questaoIdx] ? { ...copy[questaoIdx] } : {};

                if (kind === "apoio") {
                    const apoioAtual = slot.apoio || {};
                    slot.apoio = {
                        ...apoioAtual,
                        base64: dataUrl,
                        width: apoioAtual.width || 150,
                        height: apoioAtual.height || 150,
                        descricao: apoioAtual.descricao || desc
                    };
                    copy[questaoIdx] = slot;
                    return copy;
                }

                const arr = Array.isArray(copy[questaoIdx]) ? [...copy[questaoIdx]] : [];
                const atual = arr[imgIdx] || {};
                arr[imgIdx] = {
                    ...atual,
                    base64: dataUrl,
                    width: atual.width || 150,
                    height: atual.height || 150,
                    descricao: atual.descricao || desc
                };
                copy[questaoIdx] = arr;
                return copy;
            });

            // finaliza
            setAiProgress(100);
            showSnackbar("Imagem gerada e inserida!", "success");

            // aprende o tempo real dessa geração (média móvel)
            /*const dur = performance.now() - start;
            aiAvgMsRef.current = Math.min(40000, Math.max(2500, aiAvgMsRef.current * 0.75 + dur * 0.25));*/

            // limpa alvo após renderizar (pequeno delay ajuda a evitar “flash”)
            setTimeout(() => {
                setAiTarget(null);
                setAiProgress(0);
            }, 250);

        } catch (e) {

            if (e?.response?.data?.message === "Você atingiu seu limite mensal de imagens.") {
                showSnackbar(
                    isPartnerAccess
                        ? "Limite mensal de imagens do acesso parceiro atingido."
                        : getApiErrorMessage(e, "Limite de imagens atingido."),
                    "warning"
                );
                if (!isPartnerAccess) {
                    setOpenExtraImages(true);
                }
                return
            }

            showSnackbar(getApiErrorMessage(e, "Erro ao gerar imagem."), "error");
        } finally {
            if (t) clearInterval(t);
            setAiLoading(false);
        }
    };

    // Normaliza o BNCC retornado pela IA para sempre ser array de objetos {codigo, descricao}
    // const bnccArrayRaw = Array.isArray(resultado?.bncc)
    //     ? resultado.bncc
    //     : (resultado?.bncc
    //         ? [resultado.bncc] // compatibilidade se vier objeto único
    //         : []);

    const mustUppercaseTitle = (etapaVal, serieVal) => {
        if (!etapaVal || !serieVal) return false;
        const e = String(etapaVal).normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().trim();
        if (e !== 'fundamental i') return false;
        const s = String(serieVal).normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().trim();
        // aceita 1º/1°/1o e 2º/2°/2o, com/sem espaço/ponto
        return /^([12])\s*[º°o]?\.?\s*ano$/.test(s);
    };
    const IS_UPPER_TITLE = mustUppercaseTitle(etapa, serie);

    const [plano, setPlano] = useState(() => normalizePlanoFields(resultado));

    React.useEffect(() => {
        setPlano(normalizePlanoFields(resultado));
    }, [resultado]);

    const [logoBase64, setLogoBase64] = useState(null);
    const [logoAspect, setLogoAspect] = useState(null); // 'horizontal' | 'vertical'

    // Expondo a função de upload no escopo global
    window.__logoUpload = (e) => {
        const input = e.target;
        const file = input.files?.[0];
        if (!file) return;

        // Limite de 5MB (mesmo limite do ImagemUpload)
        const MAX_BYTES = 5 * 1024 * 1024;
        if (file.size > MAX_BYTES) {
            const sizeMB = (file.size / (1024 * 1024)).toFixed(2);
            showSnackbar(`Imagem muito grande (${sizeMB}MB). Tamanho máximo: ${(MAX_BYTES / (1024 * 1024)).toFixed(0)}MB.`, 'error');
            input.value = ""; // limpa para permitir re-selecionar o mesmo arquivo
            return;
        }

        const reader = new FileReader();
        reader.onload = (ev) => {
            const dataUrl = ev.target.result;
            const img = new Image();
            img.onload = () => {
                setLogoAspect(img.naturalWidth >= img.naturalHeight ? 'horizontal' : 'vertical');
                setLogoBase64(dataUrl);
            };
            img.src = dataUrl;
        };
        reader.readAsDataURL(file);

        // permitir re-selecionar o mesmo arquivo
        input.value = "";
    };

    // Remover logo
    window.__logoRemove = (e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();
        setLogoBase64("");
    };

    // Abrir seletor de arquivo (quando já existe logo)
    window.__logoTriggerUpload = (e, el) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();
        const container = el?.closest?.('[data-logo-container]');
        const input = container?.querySelector?.('input[type="file"]');
        input?.click();
    };

    // Exportações permanecem iguais
    function exportarGabaritoPDF(gabarito, titulo) {
        const html = `
        <html>
        <head>
            <meta charset="utf-8" />
        </head>
        <body style="background:#fff;">
            <h2 style="font-family:Arial;">Gabarito - ${titulo}</h2>
            <ul style="font-size:16px; font-family:Arial; padding-left: 16px;">
                ${gabarito.map(g => `<li><b>${g.numero}:</b> ${g.resposta}</li>`).join("")}
            </ul>
        </body>
        </html>
        `;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        tempDiv.style.background = "#fff";
        document.body.appendChild(tempDiv);

        html2pdf()
            .set({
                margin: 0.5,
                filename: `Gabarito_${titulo.replaceAll(" ", "_")}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true, backgroundColor: "#fff" },
                jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
            })
            .from(tempDiv)
            .save()
            .then(() => document.body.removeChild(tempDiv));
    }

    // Exportação Word/PDF - monta o HTML fiel ao render
    async function exportarWordOuPdf(tipoArquivo = "docx", orientacao = "portrait") {
        // ----- UPPERCASE apenas quando Fundamental I + (1º ano | 2º ano)
        const mustUppercase = (etapaVal, serieVal) => {
            if (!etapaVal || !serieVal) return false;
            const e = String(etapaVal).normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().trim();
            if (e !== 'fundamental i') return false;
            const s = String(serieVal).normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().trim();
            return /^([12])\s*[º°o]?\.?\s*ano$/.test(s);
        };
        const IS_UPPER = mustUppercase(etapa, serie);
        const U = v => IS_UPPER ? String(v ?? '').toUpperCase() : (v ?? '');
        const H = v => escapeHtml(U(v));

        const isDoubleExport = tipoArquivo === "pdf" && layoutMode === "double";
        const doubleExportInnerWidth =
            orientacao === "landscape"
                ? 300
                : 220;

        const exportInnerIndent = isDoubleExport ? 8 : 20;

        const svgToPngDataUrl = (svg, width = 520, height = 320) =>
            new Promise((resolve, reject) => {
                const blob = new Blob([svg], { type: "image/svg+xml;charset=utf-8" });
                const url = URL.createObjectURL(blob);
                const img = new Image();

                img.onload = () => {
                    try {
                        const canvas = document.createElement("canvas");
                        canvas.width = width;
                        canvas.height = height;

                        const ctx = canvas.getContext("2d");
                        ctx.fillStyle = "#ffffff";
                        ctx.fillRect(0, 0, width, height);
                        ctx.drawImage(img, 0, 0, width, height);

                        URL.revokeObjectURL(url);
                        resolve(canvas.toDataURL("image/png"));
                    } catch (err) {
                        URL.revokeObjectURL(url);
                        reject(err);
                    }
                };

                img.onerror = (err) => {
                    URL.revokeObjectURL(url);
                    reject(err);
                };

                img.src = url;
            });

        const graphImgHtml = async (grafico, tipoArquivoAtual, doubleColumn = false) => {
            const width = doubleColumn ? 300 : 520;
            const height = doubleColumn ? 210 : 320;
            const svg = buildGraficoSvg(grafico, { width, height });

            const src = tipoArquivoAtual === "docx"
                ? await svgToPngDataUrl(svg, width, height)
                : svgToDataUrl(svg);

            return `
                <div style="margin-left:${exportInnerIndent}px; margin-top:18px; margin-bottom:10px;">
                    <img
                        src="${src}"
                        alt="Gráfico"
                        width="${width}"
                        height="${height}"
                        style="width:${width}px; max-width:${width}px; height:${height}px; display:block; background:#fff;"
                    />
                </div>
            `;
        };

        let html = `<!DOCTYPE html>
        <html>
        <head>
        <meta charset="UTF-8" />
        </head>
        <body style="background:#fff;">
        <div style="font-family:Arial,sans-serif; font-size:16px; background:#fff; color: #222 !important">
        ${getCabecalhoHtml(tipo, logoBase64, { modo: "export" })}`;

        // Renderização condicional para plano de aula
        if (tipo && tipo.toLowerCase().includes("plano")) {

            html += buildPlanoAulaExportHtml(plano, resultado, U, H, tipoArquivo);

        } else if (questoes) {

            const tituloMarginBottom = tipoArquivo === "docx" ? 4 : 0;
            const subtituloMarginTop = tipoArquivo === "docx" ? 0 : 0;
            const subtituloMarginBottom = 28;

            html += `${resultado.tema ? `<h2 style="text-align:center; font-weight:600; margin:0 0 ${tituloMarginBottom}px 0; font-family:Arial,sans-serif; line-height:1.2;">${U(resultado.tipo_conteudo)}</h2>
            <p style="text-align:center; margin:${subtituloMarginTop}px 0 ${subtituloMarginBottom}px 0; font-family:Arial,sans-serif; line-height:1.2;">${U(resultado.disciplina)}</p>` : ""}`;

            let htmlTextoBase = "";
            let htmlProducaoTextual = "";
            let htmlQuestoes = [];

            for (let idx = 0; idx < questoes.length; idx++) {
                const q = questoes[idx];
                let blocoHtml = `<div style="margin-bottom: 18px; width: 100%; overflow: hidden;">`;

                const isTextoBase = isBlocoTextoBase(q, idx);
                const isProducaoTextualBloco = isBlocoProducaoTextual(q, idx);

                if (isTextoBase) {
                    const img = Array.isArray(imagensPorQuestao[idx]) ? imagensPorQuestao[idx][0] : null;
                    const hasImage = !!img?.base64;
                    const w = img?.width || 170;
                    const h = img?.height || 170;

                    if (hasImage) {
                        htmlTextoBase += `<table style="margin-left:${exportInnerIndent}px; margin-bottom:16px; border-collapse:collapse; width:100%;">
                                                <tr>
                                                    <td style="width:${w}px; vertical-align:top; padding-right:18px;">
                                                        <img src="${img.base64}" width="${w}" height="${h}" style="width:${w}px;height:${h}px;object-fit:contain;display:block;" />
                                                    </td>
                                                    <td style="vertical-align:top;">
                                                        <div style="color:#555;">${U(q?.conteudo_apoio?.texto || "")}</div>
                                                    </td>
                                                </tr>
                                            </table>`;
                    } else {
                        htmlTextoBase += `<div style="margin-left:${exportInnerIndent}px; margin-bottom:16px; color:#555;">${U(q?.conteudo_apoio?.texto || "")}</div>`;
                    }

                    continue;
                }

                if (isProducaoTextualBloco) {
                    htmlProducaoTextual += `<div style="margin-bottom:28px; width:100%;">`;
                    htmlProducaoTextual += `<div style="text-align:center; font-weight:700; line-height:1.7; max-width:820px; margin:0 auto 18px auto;">${U(q?.enunciado || "")}</div>`;

                    if (Array.isArray(q.imagens) && q.imagens.length > 0) {
                        const imagens = imagensPorQuestao[idx] || [];
                        const imagensHtml = q.imagens.map((img, i) => {
                            const w = Math.min((imagens[i]?.width) || 150, 220);
                            const h = Math.min((imagens[i]?.height) || 150, 220);

                            const cellHtml = imagens[i]?.base64
                                ? `<img src="${imagens[i].base64}" alt="Imagem ${i + 1}" width="${w}" height="${h}"
                    style="width:${w}px;max-width:${w}px;height:${h}px;max-height:${h}px;object-fit:contain;display:block;" />`
                                : `<div style="width:${w}px;height:${h}px;background:#fff;">&nbsp;</div>`;

                            const spacerHtml = i !== q.imagens.length - 1
                                ? `<td style="width:30px; min-width:30px; border:none;"></td>`
                                : "";

                            return `<td style="text-align:center; border:none; width:${w}px; max-width:${w}px; vertical-align:top;">
                        ${cellHtml}
                    </td>${spacerHtml}`;
                        }).join("");

                        htmlProducaoTextual += `<table style="margin:18px auto 0 auto; border-collapse:collapse;">
                                                    <tr>${imagensHtml}</tr>
                                                </table>`;
                    }

                    const totalLinhasResposta = getQuantidadeLinhasResposta(q);
                    htmlProducaoTextual += `<table style="width:100%;border-collapse:collapse;border-spacing:0;margin:18px 0 20px 0;">`;
                    for (let i = 0; i < totalLinhasResposta; i++) {
                        htmlProducaoTextual += `<tr>
                                                    <td style="border-bottom:1.5px solid #222;height:20px;line-height:0;font-size:1px;padding:0;"></td>
                                                </tr>`;
                    }
                    htmlProducaoTextual += `</table>`;
                    htmlProducaoTextual += `</div>`;

                    continue;
                }

                if (!isTextoBase) {
                    const enunciado = q.tipo === "ilustrativa" && q.enunciado
                        ? q.enunciado.replace(/\[IMAGEM\]/g, "").trim()
                        : (q.enunciado ?? "");
                    blocoHtml += `<p style="font-weight:bold; margin-top:14px;">${q.numero}. ${U(enunciado)}</p>`;
                }

                // Conteúdo de apoio (opcional)
                if (q.conteudo_apoio) {
                    if (q.conteudo_apoio.tipo === "texto" && q.conteudo_apoio.texto) {
                        blocoHtml += `<div style="margin-left:${exportInnerIndent}px; margin-bottom:10px; color:#555;">${U(q.conteudo_apoio.texto)}</div>`;
                    }

                    if (q.conteudo_apoio.tipo === "tabela") {
                        const tituloTabela = q.conteudo_apoio.titulo ? U(q.conteudo_apoio.titulo) : "";
                        const colunasTabela = Array.isArray(q.conteudo_apoio.colunas) ? q.conteudo_apoio.colunas : [];
                        const linhasTabela = Array.isArray(q.conteudo_apoio.linhas) ? q.conteudo_apoio.linhas : [];

                        if (tituloTabela) {
                            blocoHtml += `<div style="margin-left:${exportInnerIndent}px; margin-bottom:6px; color:#555;">${tituloTabela}</div>`;
                        }

                        if (colunasTabela.length || linhasTabela.length) {
                            blocoHtml += `<div style="margin-left:${exportInnerIndent}px; margin-bottom:12px;">
                                        <table style="border-collapse:collapse; background:#fff; font-size:14px;">
                                            ${colunasTabela.length ? `
                                                <thead>
                                                    <tr>
                                                        ${colunasTabela.map(col => `
                                                            <th style="border:1.5px solid #000; padding:6px 10px; font-weight:700;">
                                                                ${U(col ?? "")}
                                                            </th>
                                                        `).join("")}
                                                    </tr>
                                                </thead>
                                            ` : ""}
                                            <tbody>
                                                ${linhasTabela.map(linha => `
                                                    <tr>
                                                        ${(Array.isArray(linha) ? linha : []).map(cel => `
                                                            <td style="border:1.5px solid #000; padding:6px 10px;">
                                                                ${U(cel ?? "")}
                                                            </td>
                                                        `).join("")}
                                                    </tr>
                                                `).join("")}
                                            </tbody>
                                        </table>
                                    </div>`;
                        }
                    }
                }

                if (isQuestaoGrafico(q)) {
                    blocoHtml += await graphImgHtml(q.grafico, tipoArquivo, isDoubleExport);
                }

                // Imagens (qualquer tipo de questão)
                if (!isQuestaoGrafico(q) && Array.isArray(q.imagens) && q.imagens.length > 0) {
                    const imagens = imagensPorQuestao[idx] || [];
                    const imagensHtml = q.imagens.map((img, i) => {

                        const maxColW = isDoubleExport ? 220 : 150;

                        const w = Math.min((imagens[i]?.width) || 150, maxColW);
                        const h = Math.min((imagens[i]?.height) || 150, maxColW);

                        const cellHtml = imagens[i]?.base64
                            ? `<img src="${imagens[i].base64}" alt="Imagem ${i + 1}" width="${w}" height="${h}"
                                style="width:${w}px;max-width:${w}px;height:${h}px;max-height:${h}px;object-fit:contain;display:block;" />`
                            : `<div style="margin-left:${exportInnerIndent}px; margin-top:22px; margin-bottom:8px;">
                                    <table style="border-collapse:collapse;">
                                        <tr>
                                            <td style="
                                                width: ${isDoubleExport ? "220px" : "400px"};
                                                height: 100px;
                                                background: #fff;">
                                                &nbsp;
                                            </td>
                                        </tr>
                                    </table>
                                </div>`;

                        const spacerHtml = i !== q.imagens.length - 1
                            ? `<td style="width:30px; min-width:30px; border:none;"></td>`
                            : "";

                        return `<td style="text-align:center; border:none; width:${w}px; max-width:${w}px; vertical-align:top;">
                                    ${cellHtml}
                                </td>${spacerHtml}`;
                    }).join("");

                    blocoHtml += `<table style="
                                        margin-left:${exportInnerIndent}px;
                                        margin-top:24px;
                                        border-collapse:collapse;
                                        page-break-inside: avoid;
                                        width:${isDoubleExport ? `${doubleExportInnerWidth}px` : "auto"};
                                        max-width:${isDoubleExport ? `${doubleExportInnerWidth}px` : "100%"};
                                        table-layout:fixed;">
                                        <tr>${imagensHtml}
                                        </tr>
                                    </table>`;
                }

                // Espaço para desenho se ilustrativa e não tem alternativas/campo_resposta/imagens
                if (
                    q.tipo === "ilustrativa" &&
                    (!Array.isArray(q.alternativas) || q.alternativas.length === 0) &&
                    (!q.campo_resposta) &&
                    (!Array.isArray(q.imagens) || q.imagens.length === 0) &&
                    (!isQuestaoGrafico(q))
                ) {
                    blocoHtml += `<div style="margin-left:${exportInnerIndent}px; margin-top:22px; margin-bottom:8px;">
                            <table style="border-collapse:collapse;">
                            <tr>
                                <td style="
                                    border: 1.8px solid #222;
                                    border-radius: 12px;
                                    width: ${isDoubleExport ? "240px" : "400px"};
                                    height: ${isDoubleExport ? "140px" : "200px"};
                                    background: #fff;
                                    ">
                                    &nbsp;
                                </td>
                            </tr>
                            </table>
                            </div>`;
                }

                // Itens da ilustrativa com 1 imagem
                if (q.tipo === "ilustrativa" && Array.isArray(q.itens) && q.itens.length > 0) {
                    const itensHtml = q.itens.map((item) => {
                        const linhas = String(item?.linha_resposta || "curta").toLowerCase() === "media"
                            ? 2
                            : (disciplina.toLowerCase() !== 'matemática' ? 2 : 1);

                        const larguraLinha = isDoubleExport
                            ? (linhas === 1
                                ? Math.min(90, doubleExportInnerWidth - 120)
                                : Math.min(130, doubleExportInnerWidth - 90))
                            : 220;

                        const textoItem = U(item?.texto ?? "");

                        if (isDoubleExport) {

                            if (linhas === 1) {
                                return `<div style="
                                            width:${doubleExportInnerWidth}px;
                                            max-width:${doubleExportInnerWidth}px;
                                            margin-bottom:10px;
                                            line-height:1.45;
                                            word-break:break-word;
                                            overflow-wrap:anywhere;
                                            white-space:normal;">
                                            <span>${textoItem}</span>
                                            <span style="
                                                display:inline-block;
                                                vertical-align:baseline;
                                                width:${larguraLinha}px;
                                                max-width:${larguraLinha}px;
                                                margin-left:8px;
                                                border-bottom:1.5px solid #222;
                                                height:18px;
                                                line-height:18px;
                                            ">&nbsp;</span>
                                        </div>`;
                            }

                            return `<div style="
                                        width:${doubleExportInnerWidth}px;
                                        max-width:${doubleExportInnerWidth}px;
                                        margin-bottom:10px;
                                        line-height:1.45;
                                        word-break:break-word;
                                        overflow-wrap:anywhere;
                                        white-space:normal;">
                                        <span>${textoItem}</span>
                                        
                                        ${tipoArquivo === 'docx' ? `
                                        <div style="
                                            width:${larguraLinha}px;
                                            margin-top:6px;
                                            margin-left:auto;
                                            border-bottom:1.5px solid #222;
                                            height:18px;
                                            line-height:18px;">&nbsp;</div>`
                                    :
                                    `<span style="
                                            display:inline-block;
                                            vertical-align:baseline;
                                            width:${larguraLinha}px;
                                            max-width:${larguraLinha}px;
                                            margin-left:8px;
                                            border-bottom:1.5px solid #222;
                                            height:18px;
                                            line-height:18px;">&nbsp;</span>`}
                                    </div>`;
                        }

                        const linhasHtml = `<tr>
                                <td style="
                                    border-bottom:1.5px solid #222;
                                    height:18px;
                                    line-height:0;
                                    font-size:1px;
                                    padding:0;
                                ">
                                    &nbsp;
                                </td>
                            </tr>`

                        return `<table style="border-collapse:collapse; margin-bottom:10px; width:100%;">
                                    <tr>
                                        <td style="
                                            padding:0 8px 0 0;
                                            vertical-align:middle;
                                            width:1%;
                                            white-space:nowrap;">
                                            ${textoItem}
                                        </td>
                                        <td style="vertical-align:middle; width:220px; padding:0;">
                                            <table style="border-collapse:collapse; width:${linhas === 1 ? '40%' : '100%'};">
                                                ${linhasHtml}
                                            </table>
                                        </td>
                                    </tr>
                                </table>`;
                    }).join("");

                    blocoHtml += `<div style="margin-left:${exportInnerIndent}px; margin-top:14px; margin-bottom:8px;">${itensHtml}</div>`;
                }

                // Afirmação (opcional)
                if (q.afirmacao) {
                    blocoHtml += `<div style="margin-left:${exportInnerIndent}px; margin-top:10px; margin-bottom:4px; font-style:italic; color:#555;">${U(q.afirmacao)}</div>`;
                }

                // Alternativas (qualquer tipo, menos ilustrativa)
                if (q.alternativas && q.tipo !== "ilustrativa") {
                    const alternativasHtml = q.alternativas
                        .filter((alt) => alt !== 'Verdadeiro' && alt !== 'Falso' && alt !== 'True' && alt !== 'False')
                        .map((alt) => `<div style="margin-left: ${exportInnerIndent}px;">${U(alt)}</div>`)
                        .join("");

                    blocoHtml += alternativasHtml;
                }

                const disciplinaNormalize = String(disciplina || '')
                    .normalize('NFD')
                    .replace(/\p{Diacritic}/gu, '')
                    .toLowerCase()
                    .trim();

                // Verdadeiro/Falso (tipo específico)
                if (q.tipo === "verdadeiro_falso") {
                    blocoHtml += `<div style="margin-top: 15px; margin-left: ${exportInnerIndent}px;">(&nbsp;&nbsp;&nbsp;&nbsp;) ${disciplinaNormalize !== "ingles" ? U("Verdadeiro") : U("True")}</div>`;
                    blocoHtml += `<div style="margin-top: 5px; margin-left: ${exportInnerIndent}px;">(&nbsp;&nbsp;&nbsp;&nbsp;) ${disciplinaNormalize !== "ingles" ? U("Falso") : U("False")}</div>`;
                }

                // Campo resposta aberta (qualquer tipo)
                if (q.campo_resposta === "aberta" && q.campo_resposta !== "nao_aplicavel" && !/(desenhe|ilustre)/i.test(q.enunciado || '')) {
                    blocoHtml += `<table style="width:100%;border-collapse:collapse;border-spacing:0;margin:7px 0 0 0; margin-bottom: 20px;">`;
                    for (let i = 0; i < 4; i++) {
                        if (i < 3) {
                            blocoHtml += `<tr>
                    <td style="border-bottom:1.5px solid #222;height:20px;line-height:0;font-size:1px;padding:0;"></td>
                </tr>`;
                        } else {
                            blocoHtml += `<tr><td style="height:0;line-height:0;padding:0; margin-bottom: 20px;"></td></tr>`;
                        }
                    }
                    blocoHtml += `</table>`;
                }

                blocoHtml += `</div>`;
                htmlQuestoes.push({ html: blocoHtml, idx, q });
            };

            html += htmlTextoBase;
            html += htmlProducaoTextual;

            if (isDoubleExport) {
                const { esquerda, direita } = splitQuestoesEmDuasColunas(htmlQuestoes);
                const larguraColuna = orientacao === "landscape" ? "48%" : "47%";

                html += `<table style="width:100%; border-collapse:collapse; table-layout:fixed;">
                                <tr>
                                    <td style="width:${larguraColuna}; vertical-align:top; padding-right:16px;">
                                        ${esquerda.map(item => item.html).join("")}
                                    </td>
                                    <td style="width:${larguraColuna}; vertical-align:top; padding-left:16px;">
                                        ${direita.map(item => item.html).join("")}
                                    </td>
                                </tr>
                            </table>`;
            } else {
                html += htmlQuestoes.map(item => item.html).join("");
            }

        }

        html += "</div></body></html>";

        if (tipoArquivo === "docx") {
            const converted = htmlDocx.asBlob(html, {
                orientation: orientacao === "landscape" ? "landscape" : "portrait",
            });
            saveAs(converted, `${tipo} ${disciplina} - ${etapa} (${serie}).docx`);
        } else {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            tempDiv.style.background = "#fff";
            document.body.appendChild(tempDiv);

            html2pdf()
                .set({
                    margin: 0.5,
                    filename: `${tipo} ${disciplina} - ${etapa} (${serie}).pdf`,
                    image: { type: "jpeg", quality: 0.98 },
                    html2canvas: {
                        scale: isDoubleExport ? 1.6 : 2,
                        useCORS: true,
                        backgroundColor: "#fff"
                    },
                    jsPDF: {
                        unit: "in",
                        format: "a4",
                        orientation: orientacao === "landscape" ? "landscape" : "portrait"
                    }
                })
                .from(tempDiv)
                .save()
                .then(() => document.body.removeChild(tempDiv));
        }
    }

    // Libera exportação do gabarito para assinante ativo (A) ou parceiro (B)
    const acaoLiberada = (() => {
        const status = String(planoStatus || '').toUpperCase();
        const tipo = String(planoTipo || '').toUpperCase();
        if (!["A", "B", "I"].includes(status)) return false;
        return tipo === 'PROFESSOR' || tipo === 'MENTOR' || tipo === 'MESTRE';
    })();

    const updatePlanoArray = (field, idx, value) => {
        setPlano((p) => ({
            ...p,
            [field]: planoAsArray(p[field]).map((item, i) => i === idx ? value : item),
        }));
    };

    const updatePlanoDevelopmentField = (idx, field, value) => {
        setPlano((p) => ({
            ...p,
            desenvolvimento: planoAsArray(p.desenvolvimento).map((item, i) => {
                const normalized = normalizePlanoDevelopmentItem(item);
                return i === idx ? { ...normalized, [field]: value } : normalized;
            }),
        }));
    };

    const updatePlanoDevelopmentArray = (idx, field, itemIdx, value) => {
        setPlano((p) => ({
            ...p,
            desenvolvimento: planoAsArray(p.desenvolvimento).map((item, i) => {
                const normalized = normalizePlanoDevelopmentItem(item);
                if (i !== idx) return normalized;

                return {
                    ...normalized,
                    [field]: planoAsArray(normalized[field]).map((subItem, subIdx) => subIdx === itemIdx ? value : subItem),
                };
            }),
        }));
    };

    const updatePlanoTable = (field, updater) => {
        setPlano((p) => ({
            ...p,
            [field]: updater(normalizePlanoTable(p[field])),
        }));
    };

    const updatePlanoTableHeader = (field, idx, value) => {
        updatePlanoTable(field, (table) => ({
            ...table,
            colunas: table.colunas.map((col, i) => i === idx ? value : col),
        }));
    };

    const updatePlanoTableCell = (field, rowIdx, colIdx, value) => {
        updatePlanoTable(field, (table) => ({
            ...table,
            linhas: table.linhas.map((linha, i) => (
                i === rowIdx
                    ? linha.map((celula, j) => j === colIdx ? value : celula)
                    : linha
            )),
        }));
    };

    const PlanoSection = ({ title, children }) => {
        if (!children) return null;

        const isBlue = isPlanoBlueSection(title);

        return (
            <Box
                sx={(theme) => ({
                    mb: 2,
                    p: { xs: 1.5, md: 1.75 },
                    border: "1px solid",
                    borderColor: isBlue
                        ? alpha(theme.palette.primary.main, 0.16)
                        : theme.palette.divider,
                    borderLeft: `4px solid ${isBlue
                        ? theme.palette.primary.main
                        : alpha(theme.palette.text.primary, 0.25)
                        }`,
                    borderRadius: 2,
                    bgcolor: isBlue
                        ? alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.08 : 0.035)
                        : alpha(theme.palette.text.primary, theme.palette.mode === "dark" ? 0.04 : 0.025),
                    overflow: "hidden",
                    breakInside: "avoid",
                    pageBreakInside: "avoid",
                })}
            >
                <Typography
                    variant="subtitle1"
                    fontWeight={800}
                    sx={(theme) => ({
                        mb: 0.75,
                        letterSpacing: "-0.01em",
                        color: isBlue
                            ? theme.palette.primary.main
                            : theme.palette.text.primary,
                    })}
                >
                    {title}:
                </Typography>
                {children}
            </Box>
        );
    };


    const renderPlanoTextSection = (title, field, value = plano[field]) => {
        if (!hasPlanoValue(value)) return null;

        return (
            <PlanoSection title={title}>
                <EditableText
                    value={planoToText(value)}
                    onChange={v => setPlano(p => ({ ...p, [field]: v }))}
                    tag="div"
                    style={{ fontSize: 15, minHeight: 24 }}
                />
            </PlanoSection>
        );
    };

    const renderPlanoListSection = (title, field, value = plano[field]) => {
        const items = planoAsArray(value);
        if (!items.length) return null;

        return (
            <PlanoSection title={title}>
                <ul style={{ paddingLeft: 18, marginTop: 6, marginBottom: 0 }}>
                    {items.map((item, idx) => (
                        <li key={idx} style={{ marginBottom: 4 }}>
                            <EditableText
                                value={planoToText(item)}
                                onChange={v => updatePlanoArray(field, idx, v)}
                                tag="div"
                                style={{ fontSize: 15 }}
                            />
                        </li>
                    ))}
                </ul>
            </PlanoSection>
        );
    };

    const renderPlanoInfoTable = () => {
        const rows = [
            ["Componente Curricular", plano.disciplina || resultado?.disciplina],
            ["Ano/Série/Turma", plano.serie || resultado?.serie],
            ["Quantidade de aulas", plano.quantidade_aulas],
            ["Período de realização", plano.periodo_realizacao],
            ["Tema", plano.tema || resultado?.tema],
            ["Habilidades", plano.habilidade],
        ].filter(([, value]) => hasPlanoValue(value));

        if (!rows.length) return null;

        return (
            <Box
                sx={(theme) => ({
                    mb: 2.25,
                    overflowX: "hidden",
                    borderRadius: 2,
                    border: "1px solid",
                    borderColor: alpha(theme.palette.primary.main, 0.18),
                    bgcolor: "#fff",
                })}
            >
                <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed", fontSize: 14 }}>
                    <tbody>
                        {rows.map(([label, value]) => (
                            <tr key={label}>
                                <td style={{ width: "30%", border: "1.3px solid #222", padding: "9px 10px", fontWeight: 800, background: "#eef6ff", color: "#174ea6", verticalAlign: "top", overflowWrap: "anywhere", wordBreak: "break-word" }}>
                                    {label}
                                </td>
                                <td style={{ border: "1.3px solid #222", padding: "9px 10px", verticalAlign: "top", overflowWrap: "anywhere", wordBreak: "break-word" }}>
                                    <EditableText
                                        value={planoToText(value)}
                                        onChange={v => {
                                            const fieldByLabel = {
                                                "Componente Curricular": "disciplina",
                                                "Ano/Série/Turma": "serie",
                                                "Quantidade de aulas": "quantidade_aulas",
                                                "Período de realização": "periodo_realizacao",
                                                "Tema": "tema",
                                                "Habilidades": "habilidade",
                                            };
                                            setPlano(p => ({ ...p, [fieldByLabel[label]]: v }));
                                        }}
                                        tag="div"
                                        style={{ fontSize: 14, minHeight: 20, whiteSpace: "pre-line" }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Box>
        );
    };


    const renderPlanoDevelopment = () => {
        const items = planoAsArray(plano.desenvolvimento).map(normalizePlanoDevelopmentItem).filter(hasPlanoValue);
        if (!items.length) return null;

        return (
            <PlanoSection title="Desenvolvimento" destaque>
                <ol style={{ paddingLeft: 20, marginTop: 6 }}>
                    {items.map((item, idx) => (
                        <li key={idx} style={{ marginBottom: 14 }}>
                            {(item.titulo || item.duracao) && (
                                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "baseline", mb: 0.5 }}>
                                    {item.titulo && (
                                        <EditableText
                                            value={stripPlanoLeadingNumber(item.titulo)}
                                            onChange={v => updatePlanoDevelopmentField(idx, "titulo", stripPlanoLeadingNumber(v))}
                                            tag="strong"
                                            style={{ fontSize: 15 }}
                                        />
                                    )}
                                    {item.duracao && (
                                        <EditableText
                                            value={`(${item.duracao})`}
                                            onChange={v => updatePlanoDevelopmentField(idx, "duracao", String(v).replace(/[()]/g, ""))}
                                            tag="span"
                                            style={{ fontSize: 14, color: "#555" }}
                                        />
                                    )}
                                </Box>
                            )}

                            {item.descricao && (
                                <EditableText
                                    value={item.descricao}
                                    onChange={v => updatePlanoDevelopmentField(idx, "descricao", v)}
                                    tag="div"
                                    style={{ fontSize: 15, marginTop: 4 }}
                                />
                            )}

                            {planoAsArray(item.orientacoes).length > 0 && (
                                <Box sx={{ mt: 1 }}>
                                    <Typography component="span" fontWeight={700} fontSize={14}>Orientações: </Typography>
                                    <ul style={{ paddingLeft: 18, marginTop: 4, marginBottom: 0 }}>
                                        {planoAsArray(item.orientacoes).map((subItem, subIdx) => (
                                            <li key={subIdx}>
                                                <EditableText
                                                    value={planoToText(subItem)}
                                                    onChange={v => updatePlanoDevelopmentArray(idx, "orientacoes", subIdx, v)}
                                                    tag="div"
                                                    style={{ fontSize: 14 }}
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                </Box>
                            )}

                            {planoAsArray(item.acoes_professor).length > 0 && (
                                <Box sx={{ mt: 1 }}>
                                    <Typography component="span" fontWeight={700} fontSize={14}>Ações do professor: </Typography>
                                    <ul style={{ paddingLeft: 18, marginTop: 4, marginBottom: 0 }}>
                                        {planoAsArray(item.acoes_professor).map((subItem, subIdx) => (
                                            <li key={subIdx}>
                                                <EditableText
                                                    value={planoToText(subItem)}
                                                    onChange={v => updatePlanoDevelopmentArray(idx, "acoes_professor", subIdx, v)}
                                                    tag="div"
                                                    style={{ fontSize: 14 }}
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                </Box>
                            )}

                            {planoAsArray(item.acoes_alunos).length > 0 && (
                                <Box sx={{ mt: 1 }}>
                                    <Typography component="span" fontWeight={700} fontSize={14}>Ações dos alunos: </Typography>
                                    <ul style={{ paddingLeft: 18, marginTop: 4, marginBottom: 0 }}>
                                        {planoAsArray(item.acoes_alunos).map((subItem, subIdx) => (
                                            <li key={subIdx}>
                                                <EditableText
                                                    value={planoToText(subItem)}
                                                    onChange={v => updatePlanoDevelopmentArray(idx, "acoes_alunos", subIdx, v)}
                                                    tag="div"
                                                    style={{ fontSize: 14 }}
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                </Box>
                            )}
                        </li>
                    ))}
                </ol>
            </PlanoSection>
        );
    };

    const renderPlanoTable = (title, field) => {
        const table = normalizePlanoTable(plano[field]);
        if (!table.colunas.length && !table.linhas.length) return null;

        const showInnerTitle = table.titulo && !isSamePlanoTitle(table.titulo, title);

        return (
            <PlanoSection title={title}>
                <Box sx={{ width: "100%", overflowX: "hidden" }}>
                    {showInnerTitle && (
                        <EditableText
                            value={table.titulo}
                            onChange={v => updatePlanoTable(field, (t) => ({ ...t, titulo: v }))}
                            tag="div"
                            style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}
                        />
                    )}
                    <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed", fontSize: 14 }}>
                        {table.colunas.length > 0 && (
                            <thead>
                                <tr>
                                    {table.colunas.map((col, idx) => (
                                        <th key={idx} style={{ border: "1.3px solid #222", padding: "8px", textAlign: "left", background: "#f3f4f6", color: "#374151", overflowWrap: "anywhere", wordBreak: "break-word" }}>
                                            <EditableText
                                                value={col}
                                                onChange={v => updatePlanoTableHeader(field, idx, v)}
                                                tag="div"
                                                style={{ fontSize: 14, fontWeight: 700 }}
                                            />
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                        )}
                        <tbody>
                            {table.linhas.map((linha, rowIdx) => (
                                <tr key={rowIdx}>
                                    {linha.map((celula, colIdx) => (
                                        <td key={colIdx} style={{ border: "1.3px solid #222", padding: "8px", verticalAlign: "top", overflowWrap: "anywhere", wordBreak: "break-word" }}>
                                            <EditableText
                                                value={celula}
                                                onChange={v => updatePlanoTableCell(field, rowIdx, colIdx, v)}
                                                tag="div"
                                                style={{ fontSize: 14, minHeight: 20 }}
                                            />
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Box>
            </PlanoSection>
        );
    };


    if (!resultado) {
        return (
            <>
                <Paper sx={{ p: 4, borderRadius: 4, textAlign: "center" }}>

                    <Typography variant="body1" sx={{
                        display: "block", color: theme => theme.palette.text.secondary,
                        textAlign: "center",
                        mx: "auto",
                        fontSize: 15,
                        lineHeight: 1.6,
                    }}
                    >
                        Aguarde o processamento do documento...
                    </Typography>
                </Paper>
                <Typography variant="caption" sx={{
                    display: "block", mt: 2, color: theme => theme.palette.text.secondary,
                    textAlign: "center",
                    width: '80%',
                    mx: "auto",
                    fontSize: 13,
                    lineHeight: 1.6,
                }}
                >
                    <strong>Aviso:</strong> Este material é gerado com apoio de IA e pode conter imprecisões. Revise antes de
                    aplicar com seus alunos.
                </Typography>

            </>
        );
    }

    return (
        <>
            <Paper elevation={4} sx={{ p: { xs: 2, md: 4 }, borderRadius: 5, bgcolor: "background.paper", minHeight: 470, }}>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    gap={2}
                    mb={4}
                    flexWrap="wrap"
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Description color="primary" fontSize="large" />
                        <Typography variant="h5" fontWeight={700}>
                            Documento Gerado
                        </Typography>
                    </Box>

                    {!tipo?.toLowerCase().includes("plano") && !isMobile && (
                        <Box
                            sx={(theme) => ({
                                display: "flex",
                                alignItems: "center",
                                gap: 1.2,
                                px: 1,
                                py: 0.7,
                                borderRadius: 999,
                                bgcolor: theme.palette.background.paper,
                                border: "1px solid",
                                borderColor: theme.palette.divider,
                                boxShadow: theme.palette.mode === "dark"
                                    ? "0 4px 14px rgba(0,0,0,0.28)"
                                    : "0 4px 14px rgba(0,0,0,0.06)",
                            })}
                        >
                            <ToggleButtonGroup
                                exclusive
                                size="small"
                                value={layoutMode}
                                onChange={(_, value) => {
                                    if (value) setLayoutMode(value);
                                }}
                                disabled={isMobile}
                                sx={(theme) => ({
                                    bgcolor: theme.palette.mode === "dark"
                                        ? "rgba(255,255,255,0.04)"
                                        : "rgba(25, 118, 210, 0.06)",
                                    borderRadius: 999,
                                    p: 0.5,
                                    gap: 0.75,
                                    border: "1px solid",
                                    borderColor: theme.palette.divider,
                                    boxShadow: theme.palette.mode === "dark"
                                        ? "inset 0 1px 2px rgba(0,0,0,0.35)"
                                        : "inset 0 1px 2px rgba(16,24,40,0.06)",

                                    "& .MuiToggleButtonGroup-grouped": {
                                        border: "none !important",
                                        borderRadius: "999px !important",
                                        mx: 0,
                                    },

                                    "& .MuiToggleButton-root": {
                                        minWidth: 52,
                                        height: 40,
                                        px: 1.6,
                                        color: theme.palette.text.secondary,
                                        bgcolor: "transparent",
                                        transition: "all .18s ease",
                                        fontWeight: 700,
                                    },

                                    "& .MuiToggleButton-root:hover": {
                                        bgcolor: theme.palette.mode === "dark"
                                            ? "rgba(255,255,255,0.08)"
                                            : "rgba(25,118,210,0.08)",
                                        color: theme.palette.text.primary,
                                    },

                                    "& .Mui-selected": {
                                        bgcolor: `${theme.palette.background.paper} !important`,
                                        color: `${theme.palette.primary.main} !important`,
                                        border: `1px solid ${theme.palette.mode === "dark"
                                            ? "rgba(88,166,255,0.35)"
                                            : "rgba(25,118,210,0.22)"} !important`,
                                        boxShadow: theme.palette.mode === "dark"
                                            ? `0 1px 2px rgba(0,0,0,0.35),
                                        0 6px 18px rgba(88,166,255,0.16)`
                                            : `0 1px 2px rgba(16,24,40,0.06),
                                        0 6px 18px rgba(25,118,210,0.18)`,
                                        transform: "translateY(-1px)",
                                    },

                                    "& .Mui-selected .MuiSvgIcon-root": {
                                        color: `${theme.palette.primary.main} !important`,
                                    },

                                    "& .Mui-selected .MuiTypography-root": {
                                        color: `${theme.palette.primary.main} !important`,
                                        fontWeight: 700,
                                    },

                                    "& .Mui-selected:hover": {
                                        bgcolor: `${theme.palette.background.paper} !important`,
                                    },

                                    "& .Mui-disabled": {
                                        opacity: 0.55,
                                    }
                                })}
                            >
                                <ToggleButton value="single" aria-label="Uma coluna">
                                    <ArticleOutlinedIcon fontSize="small" sx={{ mr: 0.75 }} />
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            textTransform: "none",
                                            fontWeight: 700,
                                            letterSpacing: "-0.01em"
                                        }}
                                    >
                                        1 coluna
                                    </Typography>
                                </ToggleButton>

                                <Tooltip title="Habilitado somente para a exportação em PDF"
                                    arrow>
                                    <ToggleButton value="double" aria-label="Duas colunas">
                                        <ViewWeekOutlinedIcon fontSize="small" sx={{ mr: 0.75 }} />
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                textTransform: "none",
                                                fontWeight: 700,
                                                letterSpacing: "-0.01em"
                                            }}
                                        >
                                            2 colunas
                                        </Typography>
                                    </ToggleButton>
                                </Tooltip>
                            </ToggleButtonGroup>
                        </Box>
                    )}
                </Box>

                <Divider sx={{ my: 2 }} />

                <Box mb={2} sx={{ background: "#fff", color: "#222", minHeight: 320, borderRadius: 2 }}>
                    <div style={{ padding: 10 }} dangerouslySetInnerHTML={{ __html: getCabecalhoHtml(tipo, logoBase64, { modo: "render", aspect: logoAspect }) }} />

                    {/* Plano de Aula */}
                    {tipo && tipo.toLowerCase().includes("plano") ? (
                        <Box sx={{ px: 1, py: 2 }}>
                            {resultado.tipo_conteudo && (
                                <>
                                    <Typography
                                        variant="h5"
                                        fontWeight={600}
                                        sx={{ mb: 4, ml: 1, textAlign: 'center', display: 'block' }}
                                    >
                                        {plano.tipo_conteudo || resultado.tipo_conteudo}
                                    </Typography>
                                </>

                            )}

                            {renderPlanoInfoTable()}
                            {renderPlanoListSection("Competência Socioemocional", "competencia_socioemocional")}
                            {renderPlanoTextSection("Objeto de Conhecimento", "objeto_conhecimento")}
                            {renderPlanoTextSection("Objetivo", "objetivo")}
                            {renderPlanoListSection("Objetivos Específicos", "objetivos_especificos")}
                            {renderPlanoListSection("Espaço Físico", "espaco_fisico")}
                            {renderPlanoListSection("Metodologia", "metodologia")}
                            {renderPlanoListSection("Recursos Didáticos", "recursos_didaticos")}
                            {renderPlanoDevelopment()}
                            {renderPlanoTable("Organização da Aula", "cronograma")}
                            {renderPlanoTable("Quadro de Sistematização", "tabela_sintese")}
                            {renderPlanoListSection("Avaliação", "avaliacao")}
                            {renderPlanoTextSection("Observações", "observacoes")}
                        </Box>
                    ) : (
                        <div style={{
                            padding: 6
                        }}>

                            {resultado.tipo_conteudo && (
                                <>
                                    <Typography
                                        variant="h5"
                                        fontWeight={600}
                                        sx={{

                                            ml: 1,
                                            textAlign: 'center',
                                            display: 'block',
                                            textTransform: IS_UPPER_TITLE ? 'uppercase' : 'none',
                                        }}
                                    >
                                        {resultado.tipo_conteudo}
                                    </Typography>
                                    <Typography variant="body1" sx={{
                                        mb: 5,
                                        ml: 1,
                                        textAlign: 'center',
                                        display: 'block',
                                        textTransform: IS_UPPER_TITLE ? 'uppercase' : 'none',
                                    }}>{resultado.disciplina}</Typography>
                                </>
                            )}

                            <QuestoesRender
                                planoStatus={planoStatus}
                                questoes={questoes}
                                imagensPorQuestao={imagensPorQuestao}
                                setImagensPorQuestao={setImagensPorQuestao}
                                onChange={setQuestoes}
                                etapa={etapa}
                                serie={serie}
                                disciplina={disciplina}
                                canAI={canAI}
                                onOpenAIDialog={openAIDialog}
                                onUpgrade={handleUpgradeClick}
                                aiLoading={aiLoading}
                                aiTarget={aiTarget}
                                aiProgress={aiProgress}
                                aiStatusText={aiStatusText}
                                layoutMode={layoutMode}
                                isMobile={isMobile}
                            />
                        </div>
                    )}
                </Box>
                <Divider sx={{ my: 2 }} />

                <Box display="flex" gap={2} mt={2} mb={isMobile ? 3 : ""} justifyContent="flex-end"
                    flexDirection={isMobile ? "column" : "row"}>

                    <Button
                        sx={{ borderRadius: 1 }}
                        variant="outlined"
                        startIcon={<DescriptionIcon />}
                        color="primary"
                        onClick={(e) => openExportMenu(e, "docx")}
                    >
                        Exportar Word
                    </Button>

                    <Button
                        sx={{ borderRadius: 1 }}
                        variant="outlined"
                        startIcon={<PictureAsPdfIcon />}
                        color="secondary"
                        onClick={(e) => openExportMenu(e, "pdf")}
                    >
                        Exportar PDF
                    </Button>

                    <Menu
                        anchorEl={exportMenu.anchorEl}
                        open={Boolean(exportMenu.anchorEl)}
                        onClose={closeExportMenu}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "center",
                        }}
                        transformOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                        }}
                        slotProps={{
                            paper: {
                                elevation: 4,
                                sx: {
                                    overflow: "visible",
                                    mt: -0.5,
                                    "&::before": {
                                        content: '""',
                                        display: "block",
                                        position: "absolute",
                                        width: 12,
                                        height: 12,
                                        bgcolor: "background.paper",
                                        bottom: -6,
                                        left: "50%",
                                        transform: "translateX(-50%) rotate(45deg)",
                                        zIndex: 0,
                                    },
                                },
                            },
                        }}
                    >
                        <MenuItem onClick={() => handleEscolherOrientacao("portrait")}>
                            <CropPortraitIcon sx={{ mr: 1 }} />
                            Retrato
                        </MenuItem>

                        <MenuItem onClick={() => handleEscolherOrientacao("landscape")}>
                            <CropLandscapeIcon sx={{ mr: 1 }} />
                            Paisagem
                        </MenuItem>
                    </Menu>

                    {resultado.gabarito && resultado.gabarito.length > 0 && (
                        <HtmlTooltip
                            title={
                                acaoLiberada ? (
                                    <React.Fragment>
                                        <Typography color="primary" fontWeight="bold" mb={1}>Exportar gabarito</Typography>
                                        <span>Gera um PDF apenas com o gabarito desta atividade/avaliação.</span>
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        <Typography color="primary" fontWeight="bold" mb={1}>Recurso indisponível</Typography>
                                        <span>A exportação de gabarito está disponível apenas para os planos <b>Mentor</b> e <b>Mestre</b>.</span><br />
                                        <span><b>Cancele</b> o seu plano atual e faça upgrade para liberar este recurso.</span>
                                    </React.Fragment>
                                )
                            }
                        >
                            {/* span necessário para tooltip funcionar em botão desabilitado */}
                            <span style={{ display: 'inline-block' }}>
                                <Button
                                    sx={{ borderRadius: 1 }}
                                    variant="outlined"
                                    startIcon={<LibraryAddCheckIcon />}
                                    color="success"
                                    onClick={acaoLiberada ? () => exportarGabaritoPDF(resultado.gabarito, tipo) : undefined}
                                    disabled={!acaoLiberada}
                                    fullWidth
                                >
                                    Exportar Gabarito
                                </Button>
                            </span>
                        </HtmlTooltip>
                    )}
                </Box>

                {mostrarAvaliacao && (
                    <Box
                        sx={{
                            mt: 3,
                            p: 2.5,
                            borderRadius: 2,
                            border: (theme) => `1px dashed ${theme.palette.primary.main}`,
                            textAlign: "center",
                            maxWidth: 600,
                            mx: "auto"
                        }}
                    >
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                            Nos ajude a deixar a Docen ainda melhor 🙌
                        </Typography>
                        <Typography variant="body2" sx={{ mb: 1.5 }}>
                            {tipoChamadaAvaliacao === "primeira_avaliacao_trial" && (
                                "Essa foi sua primeira experiência com a plataforma."
                            )}

                            {/*tipoChamadaAvaliacao === "terceira_avaliacao_trial" && (
                                "Agora que você já gerou alguns conteúdos, como está sendo sua experiência?"
                            )*/}

                            {tipoChamadaAvaliacao === "avaliacao_assinante" && (
                                "Como está sendo sua experiência com a plataforma?"
                            )}

                            {tipoChamadaAvaliacao === "avaliacao_mensal_assinante" && (
                                "Começando mais um mês com a Docen! Como você avaliaria sua experiência até aqui?"
                            )}

                            {!tipoChamadaAvaliacao && (
                                "Como está sendo sua experiência com a plataforma?"
                            )}
                        </Typography>

                        <Typography variant="body2" sx={{ mb: 2 }}>
                            Sua opinião leva alguns segundos e ajuda a melhorar os próximos resultados para você e outros professores.
                        </Typography>
                        <Button
                            sx={{ borderRadius: 1, pl: 2, pr: 2, textTransform: "none" }}
                            variant="contained"
                            size="small"
                            onClick={() => onAvaliarClick && onAvaliarClick()}
                        >
                            Avaliar e ajudar a melhorar

                        </Button>
                    </Box>
                )}

            </Paper>
            <Typography variant="caption" sx={{
                display: "block", mt: 2, color: theme => theme.palette.text.secondary,
                textAlign: "center",
                width: '80%',
                mx: "auto",
                fontSize: 13,
                lineHeight: 1.6,
            }}
            >
                <strong>Aviso:</strong> Este material é gerado com apoio de IA e pode conter imprecisões. Revise antes de
                aplicar com seus alunos.
            </Typography>

            <AIGerarImagemDialog
                open={aiOpen}
                onClose={closeAIDialog}
                onGenerate={handleGenerateAI}
                locked={!canAI}
                loading={aiLoading}
                onUpgrade={handleUpgradeClick}
            />

            <UpgradePlanDialog
                open={openUpgrade}
                onClose={() => setOpenUpgrade(false)}
                userId={user?.id}
                planoAtual={planoTipo}
                presetPlan="MESTRE"
                onlyPlan={upgradeOptionsForAI}
                onUpgraded={async () => {
                    // atualiza contexto do plano SEM refresh de página
                    await fetchStatusPlano(user?.id);

                    showSnackbar("Upgrade concluído! Agora você já pode gerar imagens com IA.", "success");
                    setOpenUpgrade(false);
                }}
            />

            <ExtraImagesPackageDialog
                open={openExtraImages}
                onClose={() => setOpenExtraImages(false)}
                onPaid={async (data) => {
                    await fetchStatusPlano(user?.id);
                    showSnackbar(
                        `Pagamento confirmado! ${data?.quantity || 0} imagens adicionadas ao seu saldo.`,
                        "success"
                    );
                    setOpenExtraImages(false);
                }}
            />

        </>
    );
}